import React, { useMemo, useState, useEffect, useCallback } from 'react';



import { useNavigate } from 'react-router-dom';



import { useAuth } from '../hooks/useAuth';



import api from '../services/api';



import MainLayout from '../components/layout/MainLayout';



import AgendaSection from '../components/ui/AgendaSection';



import AlertesPanel from '../components/shared/AlertesPanel';



import DecisionsPanel from '../components/shared/DecisionsPanel';



import { TaskManagementModule } from '../components/rh';
import { ProcesVerbauxRH } from '../components/rh';



import FormModal from '../components/shared/FormModal'; // ? adaptez le chemin selon votre arborescence



import './DashboardDGPage.css';
import DeptOverviewSection from '../components/shared/DeptOverviewSection';
import { useMobileSidebar } from '../hooks/useMobileSidebar';
import { PresenceFilterSection } from '../components/dashboard';
import { usePresenceFilter } from '../hooks/usePresenceFilter';







// -- Helpers de mapping API ? UI ----------------------------------------------



const COLORS_CYCLE = ['#C9A84C', '#42a5f5', '#66bb6a', '#ab47bc', '#ff9800', '#26c6da', '#ef5350', '#64b5f6'];



const colorFor = (str) => COLORS_CYCLE[(str || '').length % COLORS_CYCLE.length];







// --- CORRIGÉ : Gère le format avec user imbriqué (architecture User + Employee) ---

const mapEmployee = (e) => {
  const u = e.user || {};
  const dept = u.departement || {};
  const filiale = u.filiale || dept.filiale || {};
  const prenom = u.prenom || '';
  let nom = u.nom || '';
  // Si nom contient déjà le prénom (ex: "Sylvio MONGBO"), extraire seulement le nom de famille
  if (prenom && nom.startsWith(prenom + ' ')) {
    nom = nom.slice(prenom.length + 1).trim();
  }
  const nomComplet = `${prenom} ${nom}`.trim();
  const av = ((prenom || 'X')[0] + (nom || 'X')[0]).toUpperCase();

  // 🔧 NOUVEAU : Récupérer les données de pointage de l'API
  const pointageHeure = e.pointage_heure || null;
  const pointageHeureFin = e.pointage_heure_fin || null;
  const pointageStatut = e.pointage_statut || 'absent';
  const hasPointage = e.has_pointage || false;
  
  // 🔍 DEBUG : Afficher les données de pointage reçues
  if (nomComplet) {
    console.log(`📊 ${nomComplet}:`, {
      pointage_heure: e.pointage_heure,
      pointage_heure_fin: e.pointage_heure_fin,
      pointage_statut: e.pointage_statut,
      has_pointage: e.has_pointage
    });
  }
  
  // Déterminer le statut de présence basé sur les pointages
  const present = hasPointage && (pointageStatut === 'ok' || pointageStatut === 'retard');
  const arr = pointageHeure || '—';
  const fin = pointageHeureFin || '—';

  return {
    _id: e.id,
    id: e.id,                    // ID Employee
    user_id: u.id || e.user_id,  // 🔧 ID User - CRUCIAL pour matcher avec employee_id des tâches
    nom: nomComplet,
    prenom: prenom,
    nom_raw: nom,
    poste: u.poste || '—',
    filiale: filiale.nom || '—',
    filiale_id: filiale.id || u.filiale_id || null,
    departement: dept.nom || '',
    departement_id: u.departement_id || dept.id || null,
    
    // 🔧 DONNÉES DE POINTAGE
    arr: arr,
    fin: fin,
    present: present,
    pointage_statut: pointageStatut,
    has_pointage: hasPointage,
    
    taches: e.taches_quotidiennes || 0,
    done: e.taches_completees || 0,

    av,

    color: e.color || colorFor(nomComplet),

    score: e.score_performance || 0,

    score_performance: e.score_performance || 0,



    score_presence: e.score_presence || 0,



    score_delai_taches: e.score_delai_taches || 0,



    score_objectifs: e.score_objectifs || 0,



    score_travail_equipe: e.score_travail_equipe || 0,



    score_respect_regles: e.score_respect_regles || 0,



    assignedTasks: [], // ?? Initialiser le tableau (sera rempli apr�s)



  };



};







const mapProject = (p) => {



  const owner = p.owner || {};



  const filiale = p.filiale || {};



  const dept = p.departement || {};







  return {



    _id: p.id,



    id: p.id,



    nom: p.name || p.nom || '�',



    filiale: filiale.nom || p.filiale_nom || '�',



    filiale_id: filiale.id || p.filiale_id || null,



    departement: dept.nom || p.departement_nom || '�',



    departement_id: dept.id || p.departement_id || null,



    av: p.progress || p.av || 0,



    deadline: p.end_date ? p.end_date.slice(0, 10) : (p.deadline || ''),



    deadline_display: p.end_date ? p.end_date.slice(5).split('-').reverse().join('/') : (p.deadline || '�'),



    statut: p.status || p.statut || 'planifie',



    budget: p.budget || 0,



    dep: p.depenses || p.dep || 0,



    resp: owner.prenom ? `${owner.prenom || ''} ${(owner.nom || '')[0] || ''}.`.trim() : (p.resp || '�'),



    resp_id: p.owner_id || p.resp_id || null,



    // ?? CORRIG� : Parser correctement l'�quipe



    equipe: p.team?.map(e => e.id) || p.equipe || [],



    equipe_noms: p.team?.map(e => {



      const u = e.user || e;



      return `${u.prenom || ''} ${(u.nom || '')[0]}.`.trim();



    }) || p.equipe_noms || [],



    description: p.description || '',



  };



};







const mapTask = (t) => ({



  id: t.id,



  _id: t.id,



  text: t.titre || t.text || '�',



  titre: t.titre || t.text || '�',        // ?? Pour TaskManagementModule



  done: !!t.done,



  date: t.deadline ? t.deadline.slice(0, 10) : (t.date || TODAY_STR),



  priorite: t.priority || t.priorite || 'normale',



  categorie: t.category || t.categorie || 'Admin',



  employee_id: t.employee_id || null,      // ?? CRUCIAL



  employee: t.employee || null,



  assigned_by: t.assigned_by || null,



  statut: t.statut || (t.done ? 'termine' : 'a_faire'),  // ?? Pour TaskManagementModule



  progression: t.progression || (t.done ? 100 : 0),      // ?? Pour TaskManagementModule



  description: t.description || '',



  dateEcheance: t.deadline ? t.deadline.slice(0, 10) : '', // ?? Pour TaskManagementModule



  document_preuve: t.document_preuve || null,



  completed_at: t.completed_at || null,



});



const mapFiliale = (f) => ({



  _id: f.id,



  id: f.id,



  icon: '??',



  nom: f.nom || '�',



  desc: f.description || f.nom,



  resp: f.responsable || '�',



  projets: f.projets_count || 0,



  ca: f.ca_realise || '0',



  obj: f.objectif_ca || '1000000',



  pct: f.objectif_ca ? Math.min(100, Math.round(((f.ca_realise || 0) / f.objectif_ca) * 100)) : 0,



  color: colorFor(f.nom),



  statut: f.statut || 'active',



});







// --- CORRIG� : G�re les relations depuis l'API ---



const mapDept = (d) => ({



  _id: d.id,



  id: d.id,



  nom: d.nom || '�',



  chef: d.chef?.user ? `${d.chef.user.prenom || ''} ${d.chef.user.nom || ''}`.trim() : (d.chef_nom || '-'),



  chef_id: d.chef_id || d.chef?.id || null,



  effectif: d.effectif || d.employees_count || 0,



  filiale: d.filiale?.nom || d.filiale_nom || '�',



  filiale_id: d.filiale_id || d.filiale?.id || null,



  budget: d.budget ? `${(d.budget / 1000000).toFixed(1)} M` : '�',



});











const TOGGLES = ['Alertes retards collaborateurs', 'Notifications t�ches non coch�es', 'Alertes d�passement budget projet', 'Rapport hebdomadaire automatique', 'Alertes expiration contrats'];







// -- Helpers ------------------------------------------------------------------



const fmt = n => n >= 1000000 ? (n / 1000000).toFixed(1) + 'M' : n >= 1000 ? (n / 1000).toFixed(0) + 'k' : n;







function Pbar({ pct, color }) {



  const c = color || (pct >= 70 ? '#4caf50' : pct >= 40 ? '#ff9800' : '#ef5350');



  return (



    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>



      <div className="pbar-wrap" style={{ flex: 1 }}>



        <div className="pbar-fill" style={{ width: `${pct}%`, background: c }} />



      </div>



      <span style={{ fontSize: 10, color: '#778', width: 28, textAlign: 'right' }}>{pct}%</span>



    </div>



  );



}







function Badge({ statut }) {



  const map = { en_cours: ['green', 'En cours'], retard: ['red', 'Retard'], planifie: ['blue', 'Planifi�'], termine: ['purple', 'Termin�'], attente: ['orange', 'En attente'], active: ['green', 'Active'], dev: ['blue', 'D�veloppement'], URGENT: ['red', 'URGENT'], HAUTE: ['orange', 'HAUTE'], NORMALE: ['blue', 'NORMALE'] };



  const [cls, lbl] = map[statut] || ['gold', statut];



  return <span className={`badge ${cls}`}>{lbl}</span>;



}







function SecTitle({ children }) {



  return <div className="sec-title">{children}</div>;



}







function AlertItem({ dot, txt, time }) {



  return (



    <div className="alert-item">



      <div className="alert-dot" style={{ background: dot }} />



      <div>



        <div className="alert-text" dangerouslySetInnerHTML={{ __html: `<strong>${txt.split('�')[0]}</strong>${txt.includes('�') ? '�' + txt.split('�').slice(1).join('�') : ''}` }} />



        <div className="alert-time">{time}</div>



      </div>



    </div>



  );



}







// -- Constante statique (hors composant) --------------------------------------



const TODAY_STR = new Date().toISOString().slice(0, 10);







// -- Composant principal -------------------------------------------------------



function DashboardDGPage() {



  const [loading, setLoading] = useState(true);



  const [dashStats, setDashStats] = useState({});



  const [activePage, setActivePage] = useState('vue-globale');



  const [now, setNow] = useState(new Date());



  const [notifOpen, setNotifOpen] = useState(false);



  const [tasks, setTasks] = useState([]);



  const [taskCalDate, setTaskCalDate] = useState(TODAY_STR);



  const [taskCalNav, setTaskCalNav] = useState(() => { const d = new Date(); return { y: d.getFullYear(), m: d.getMonth() }; });



  const [projets, setProjets] = useState([]);



  const [filiales, setFiliales] = useState([]);



  const [personnel, setPersonnel] = useState([]);



  const [financeRows, setFinanceRows] = useState([]);



  const [depts, setDepts] = useState([]);



  const [employes, setEmployes] = useState([]);



  const [modal, setModal] = useState(null);



  const [form, setForm] = useState({});



  const [toggles, setToggles] = useState([true, true, true, false, false]);



  const [selectedFiliale, setSelectedFiliale] = useState(null);



  const [selectedProjet, setSelectedProjet] = useState(null);



  const [selectedDept, setSelectedDept] = useState(null);



  const [decisions, setDecisions] = useState([]);



  const [presenceDate, setPresenceDate] = useState(() => new Date().toISOString().slice(0, 10));



  const [presenceLogs, setPresenceLogs] = useState({});



  const [presenceCodes, setPresenceCodes] = useState({});



  const [codeTargetDate, setCodeTargetDate] = useState(() => {



    const d = new Date(); d.setDate(d.getDate() + 1); return d.toISOString().slice(0, 10);



  });



  const [demoValidNom, setDemoValidNom] = useState('');



  const [demoValidCode, setDemoValidCode] = useState('');



  const [demoValidMsg, setDemoValidMsg] = useState(null);



  // �tats pour les demandes de permission



  const [demandesPermission, setDemandesPermission] = useState([]);



  const [activeTab, setActiveTab] = useState('en_attente');



  const [modalDemande, setModalDemande] = useState(null);



  const [commentaireDG, setCommentaireDG] = useState('');



  const [actionType, setActionType] = useState(null); // 'approuver' ou 'refuser'



  const [projetFilialeId, setProjetFilialeId] = useState(null);

  const [objectifs, setObjectifs] = useState([]);

  const [objectifForm, setObjectifForm] = useState({});

  const [objectifFilters, setObjectifFilters] = useState({ type_periode: 'quotidien' });

  // Hook pour le filtre de présence par jour
  const {
    presenceDate: presenceDateFiltered,
    setPresenceDate: setPresenceDateFilter,
    presenceStats,
    loading: presenceLoading,
  } = usePresenceFilter();

  // États pour synchroniser avec le hook (pour rétrocompatibilité)
  const [localPresenceDate, setLocalPresenceDate] = useState(() => new Date().toISOString().slice(0, 10));



  const todayStr = TODAY_STR;



  // -- Fonction pour charger les demandes de permission -----------------------

  const loadDemandesPermission = useCallback(async () => {

    try {

      const response = await api.demandesPermission.getAll();

      setDemandesPermission(response.demandes || []);

    } catch (error) {

      console.error('Erreur lors du chargement des demandes:', error);

    }

  }, []);







  // -- Chargement initial depuis l'API -----------------------------------------

  useEffect(() => {

    const loadAll = async () => {

      try {

        setLoading(true);

        // 🔧 CORRECTION : Utiliser la date filtrée pour charger les données enrichies
        const dateParam = presenceDateFiltered || new Date().toISOString().slice(0, 10);

        // --- CORRIGÉ : Utilise les bonnes méthodes API avec le paramètre date ---

        const [dgData, tasksData, filialesData, deptsData, finData, codeData] = await Promise.allSettled([

          api.dashboard.dg({ date: dateParam }),  // 🔧 AJOUT du paramètre date

          api.tasks.getAll(),

          api.filiales.getAll(),      // ? CORRIGÉ : .getAll()

          api.departements.getAll(),  // ? CORRIGÉ : .getAll()



          api.finance.synthese(),



          api.codeJour(),



        ]);


        // Charger les demandes de permission

        loadDemandesPermission();








        console.log('?? R�sultats chargement:', {



          dg: dgData.status,



          tasks: tasksData.status,



          filiales: filialesData.status,



          depts: deptsData.status



        });







        // ?? CORRIG� : Charger D'ABORD toutes les t�ches pour pouvoir les distribuer



        let allTasks = [];



        if (tasksData.status === 'fulfilled' && tasksData.value?.tasks?.length) {



          allTasks = tasksData.value.tasks.map(mapTask);



          setTasks(allTasks);



          console.log('?? T�ches charg�es:', allTasks.length, allTasks.map(t => ({ id: t.id, employee_id: t.employee_id, text: t.text })));



        }







        if (dgData.status === 'fulfilled' && dgData.value) {



          const dg = dgData.value;



          setDashStats(dg.stats || {});







          if (dg.employees?.length) {



            const mapped = dg.employees.map(mapEmployee);







            // ?? CORRIG� : Distribuer les t�ches aux employ�s par user_id



            const employeesWithTasks = mapped.map(emp => {



              // Matcher par user_id (car employee_id dans les t�ches = user_id)



              const empTasks = allTasks.filter(t => t.employee_id === emp.user_id);







              console.log(`?? ${emp.nom} (user_id: ${emp.user_id}): ${empTasks.length} t�ches`);







              return {



                ...emp,



                assignedTasks: empTasks,



                // Mettre � jour les compteurs pour coh�rence



                taches: empTasks.length,



                done: empTasks.filter(t => t.done).length,



              };



            });







            console.log('? Employ�s avec t�ches:', employeesWithTasks.map(e => ({



              nom: e.nom,



              user_id: e.user_id,



              tasksCount: e.assignedTasks.length



            })));







            setPersonnel(employeesWithTasks);



            setEmployes(employeesWithTasks);



          }







          if (dg.projects?.length) setProjets(dg.projects.map(mapProject));



          if (dg.recent_tasks?.length) {



            // �viter le doublon si recent_tasks est d�j� dans allTasks



            const recentMapped = dg.recent_tasks.map(mapTask);



            setTasks(prev => {



              const existingIds = new Set(prev.map(t => t.id));



              const newTasks = recentMapped.filter(t => !existingIds.has(t.id));



              return [...prev, ...newTasks];



            });



          }



        }







        // --- CORRIG� : G�re plusieurs formats de r�ponse Laravel ---



        if (filialesData.status === 'fulfilled' && filialesData.value) {



          const fList = filialesData.value.data ||



            filialesData.value.filiales ||



            (Array.isArray(filialesData.value) ? filialesData.value : []);



          if (fList.length) {



            console.log('? Filiales charg�es:', fList.length);



            setFiliales(fList.map(mapFiliale));



          }



        }







        if (deptsData.status === 'fulfilled' && deptsData.value) {



          const dList = deptsData.value.data ||



            deptsData.value.departements ||



            (Array.isArray(deptsData.value) ? deptsData.value : []);



          if (dList.length) {



            console.log('? D�partements charg�s:', dList.length, dList);



            setDepts(dList.map(mapDept));



          }



        }







        if (finData.status === 'fulfilled' && finData.value?.par_filiale?.length) {



          setFinanceRows(finData.value.par_filiale.map(r => ({



            _id: r.filiale_id,



            f: r.filiale || r.nom || '�',



            ca: `${Number(r.total || 0).toLocaleString('fr-FR')} FCFA`,



            pct: r.pct ? `${r.pct}%` : '�',



            t: r.tendance || 'green',



            tb: r.tb || '',



          })));



        }







        if (codeData.status === 'fulfilled' && codeData.value?.code && codeData.value?.date)



          setPresenceCodes(prev => ({ ...prev, [codeData.value.date]: codeData.value.code }));







      } catch (e) {



        console.error('Dashboard DG load error:', e);



      } finally {



        setLoading(false);



      }



    };



    loadAll();



    const t = setInterval(() => setNow(new Date()), 60000);



    return () => clearInterval(t);



  }, []);

  // 🔧 NOUVEAU : Recharger les employés quand la date de présence change
  useEffect(() => {
    const reloadEmployeesWithDate = async () => {
      if (!presenceDateFiltered || loading) return;
      
      try {
        console.log('🔄 Rechargement employés pour date:', presenceDateFiltered);
        
        const response = await api.dashboard.dg({ date: presenceDateFiltered });
        
        if (response && response.employees) {
          const mapped = response.employees.map(mapEmployee);
          
          // Distribuer les tâches existantes
          const employeesWithTasks = mapped.map(emp => {
            const empTasks = tasks.filter(t => t.employee_id === emp.user_id);
            return {
              ...emp,
              assignedTasks: empTasks,
              taches: empTasks.length,
              done: empTasks.filter(t => t.done).length,
            };
          });
          
          setPersonnel(employeesWithTasks);
          setEmployes(employeesWithTasks);
          setDashStats(response.stats || {});
          
          console.log('✅ Employés rechargés avec pointages');
        }
      } catch (error) {
        console.error('❌ Erreur rechargement:', error);
      }
    };
    
    reloadEmployeesWithDate();
  }, [presenceDateFiltered]);

  
  // -- Chargement des objectifs avec filtres ----------------------------------
  useEffect(() => {
    const loadObjectifs = async () => {
      try {
        const filters = {};
        if (objectifFilters.type_periode) filters.type_periode = objectifFilters.type_periode;
        if (objectifFilters.date_objectif) filters.date_objectif = objectifFilters.date_objectif;
        if (objectifFilters.semaine) filters.semaine = objectifFilters.semaine;
        if (objectifFilters.employee_id) filters.employee_id = objectifFilters.employee_id;
        
        const res = await api.objectifs.getAll(filters);
        setObjectifs(res.objectifs || []);
      } catch (error) {
        console.error('Erreur chargement objectifs:', error);
      }
    };
    loadObjectifs();
  }, [objectifFilters]);



  const generateCode = () => {



    api.genererCode(codeTargetDate)



      .then(data => { setPresenceCodes(prev => ({ ...prev, [data.date]: data.code })); })



      .catch(() => { });



  };







  const validerCodeEmploye = () => {



    const expected = presenceCodes[todayStr];



    if (!expected) { setDemoValidMsg({ ok: false, msg: "Aucun code g�n�r� pour aujourd'hui." }); return; }



    if (expected !== demoValidCode.trim().toUpperCase()) { setDemoValidMsg({ ok: false, msg: 'Code incorrect.' }); return; }



    if (!demoValidNom) { setDemoValidMsg({ ok: false, msg: 'S�lectionner un employ�.' }); return; }



    const n = new Date();



    const heure = n.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });



    const heureNum = n.getHours() * 100 + n.getMinutes();



    const statut = heureNum <= 830 ? 'ok' : 'retard';



    setPresenceLogs(prev => ({ ...prev, [todayStr]: { ...(prev[todayStr] || {}), [demoValidNom]: heure } }));



    const msg = statut === 'ok'



      ? `Pr�sence valid�e pour ${demoValidNom} � ${heure}`



      : `Pr�sence valid�e pour ${demoValidNom} � ${heure} (RETARD - limite 8h30)`;



    setDemoValidMsg({ ok: true, msg });



    setDemoValidNom('');



    setDemoValidCode('');



  };







  // 🔧 CORRECTION FINALE : personnelDuJour utilise directement les données enrichies de l'API
  // Les employés dans 'personnel' ont déjà pointage_statut, pointage_heure, present, arr
  const personnelDuJour = useMemo(() => {
    // Retourner personnel tel quel - les données sont déjà enrichies par le backend
    return personnel;
  }, [personnel]);

  const totalTasks = employes.reduce((sum, emp) => sum + (emp.assignedTasks || []).length, 0);







  const formattedDate = useMemo(() => now.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' }), [now]);



  const lastUpdate = useMemo(() => now.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' }), [now]);







  const navigate = useNavigate();
  useMobileSidebar();



  const { logout: authLogout } = useAuth();



  const { user } = useAuth();







  const handleLogout = async () => {



    await authLogout();



    navigate('/auth', { replace: true });



  };







  const openModal = useCallback((type, data = {}) => { setForm(data); setModal(type); }, []);



  const closeModal = useCallback(() => { setModal(null); setForm({}); }, []);







  // -- Fonctions de sauvegarde (re�oivent formData depuis FormModal) ----------



  const saveTask = async (formData) => {  // ? AJOUTER le param�tre



    const data = formData || form;







    if (!data.text) {



      alert('Veuillez saisir l\'intitul� de la t�che');



      return;



    }







    console.log('?? Sauvegarde de la t�che - Form data:', data);







    try {



      const payload = {



        titre: data.text,



        priority: data.priorite || 'normale',



        category: data.categorie || 'Admin',



        deadline: data.date || todayStr,



        employee_id: user?.id || null,  // Assign�e au DG



      };







      console.log('?? Donn�es envoy�es � l\'API (t�che):', payload);







      if (data._id) {



        const res = await api.tasks.update(data._id, payload);



        console.log('? R�ponse API (update t�che):', res);



        setTasks(prev => prev.map(t => t.id === data._id ? mapTask(res.task || res) : t));



      } else {



        const res = await api.tasks.create(payload);



        console.log('? R�ponse API (create t�che):', res);



        setTasks(prev => [...prev, mapTask(res.task || res)]);



      }



      closeModal();



    } catch (error) {



      console.error('? Erreur lors de la sauvegarde de la t�che:', error);



      if (data._id) {



        setTasks(prev => prev.map(t => t.id === data._id ? { ...t, text: data.text, priorite: data.priorite || 'normale', categorie: data.categorie || 'Admin', date: data.date || todayStr } : t));



      } else {



        setTasks(prev => [...prev, { id: Date.now(), text: data.text, done: false, date: data.date || todayStr, priorite: data.priorite || 'normale', categorie: data.categorie || 'Admin' }]);



      }



      closeModal();



      alert('T�che sauvegard�e localement (erreur de connexion au serveur)');



    }



  };







    const saveProjet = async (formData) => {



    const data = formData || form;







    if (!data.nom) {



      alert('Veuillez saisir le nom du projet');



      return;



    }







    if (!data.filiale_id) {



      alert('Veuillez s�lectionner une filiale');



      return;



    }







    console.log('?? Sauvegarde du projet - Form data:', data);







    try {



      // ?? CORRIG� : S'assurer que team contient des IDs Employee valides



      const teamIds = (data.equipe || [])



        .map(id => Number(id))



        .filter(id => !isNaN(id) && id > 0);







      console.log('?? Team IDs envoy�s:', teamIds);







      const payload = {



        name: data.nom,



        description: data.description || '',



        status: data.statut || 'planification',



        filiale_id: Number(data.filiale_id),



        departement_id: data.departement_id ? Number(data.departement_id) : null,



        owner_id: data.resp_id ? Number(data.resp_id) : null,



        budget: Number(data.budget) || 0,



        start_date: new Date().toISOString().slice(0, 10),



        end_date: data.deadline || null,



        progress: Number(data.av) || 0,



        team: teamIds,  // ?? IDs Employee num�riques



      };







      console.log('?? Payload final:', payload);







      if (data._isEdit && data._id) {



        const res = await api.projectsCRUD.update(data._id, payload);



        console.log('? R�ponse API (update projet):', res);



        setProjets(prev => prev.map(p => p._id === data._id ? mapProject(res.project || res) : p));



        alert('? Projet modifi� avec succ�s!');



      } else {



        const res = await api.completeResources.createProject(payload);



        console.log('? R�ponse API (create projet):', res);



        if (res.success || res.project || res.id) {



          setProjets(prev => [...prev, mapProject(res.project || res)]);



          alert('? Projet cr�� avec succ�s!');



        }



      }



      closeModal();



      setProjetFilialeId(null);



    } catch (error) {



      console.error('? Erreur lors de la sauvegarde du projet:', error);



      // ?? Afficher le d�tail de l'erreur 422



      if (error.status === 422 && error.data) {



        const details = Object.entries(error.data.errors || {})



          .map(([field, msgs]) => `${field}: ${msgs.join(', ')}`)



          .join('\n');



        alert('Erreur de validation:\n' + details);



      } else {



        alert('Erreur lors de la sauvegarde: ' + (error.message || 'Erreur inconnue'));



      }



    }



  };



  const deleteProjet = async (p) => {



    if (p._id) {



      try {



        await api.projectsCRUD.delete(p._id);



      } catch { }



    }



    setProjets(prev => prev.filter(x => x.nom !== p.nom));



  };



  const saveFiliale = async (formData) => {  // ? AJOUTER le param�tre



    const data = formData || form;







    console.log('?? Sauvegarde de la filiale - Form data:', data);







    if (!data.nom) {



      alert('Veuillez saisir le nom de la filiale');



      return;



    }







    try {



      if (data._isEdit && data._id) {



        const payload = {



          nom: data.nom,



          description: data.desc || data.description || '',



          ca: data.ca,



          obj: data.obj,



        };



        const res = await api.filiales.update(data._id, payload);



        setFiliales(prev => prev.map(f => f.id === data._id ? { ...mapFiliale(res.filiale || res), ca: data.ca, obj: data.obj, pct: f.pct } : f));



      } else {



        const payload = {



          nom: data.nom,



          description: data.desc || data.description || '',



          adresse: data.adresse || '',



          telephone: data.telephone || '',



          email: data.email || '',



          responsable_id: data.responsable_id ? Number(data.responsable_id) : null,



        };







        console.log('?? Donn�es envoy�es � l\'API (create filiale):', payload);







        const res = await api.completeResources.createFiliale(payload);



        console.log('? R�ponse API (create filiale):', res);







        if (res.success || res.filiale || res.id) {



          const newFiliale = mapFiliale(res.filiale || res);



          setFiliales(prev => [...prev, newFiliale]);



          alert('? Filiale cr��e avec succ�s!');



        }



      }



      closeModal();



    } catch (error) {



      console.error('? Erreur lors de la sauvegarde de la filiale:', error);



      alert('Erreur lors de la sauvegarde: ' + (error.message || 'Erreur inconnue'));



    }



  };



  const deleteFiliale = async (nom) => {



    const filiale = filiales.find(f => f.nom === nom);



    if (!filiale) return;



    if (!window.confirm(`Supprimer la filiale "${nom}" ? Cette action est irr�versible.`)) return;



    try {



      await api.filiales.delete(filiale.id);



      setFiliales(prev => prev.filter(f => f.nom !== nom));



    } catch (error) {



      alert('Erreur lors de la suppression: ' + (error.message || 'Erreur inconnue'));



    }



  };







  const savePersonnel = async (formData) => {



    console.log('?? savePersonnel appel� avec:', formData);







    const data = formData;



    const prenom = data?.prenom ?? data?.av ?? '';



    const nom = data?.nom ?? '';







    if (!prenom.trim() || !nom.trim()) {



      alert('Veuillez remplir le pr�nom et le nom');



      return { success: false, error: 'VALIDATION' };



    }







    // R�solution du d�partement



    let departementId = null;



    if (data.departement_id) {



      departementId = Number(data.departement_id);



    } else if (data.departement) {



      const deptObj = depts.find(d => d.id === Number(data.departement) || d.nom === data.departement);



      departementId = deptObj?.id ?? null;



    }







    // R�solution de la filiale



    // ?? La filiale sera automatiquement r�cup�r�e par le backend depuis le d�partement



    try {



      let response;



      let processedEmployee;







      if (data._isEdit && data.id) {



        // --- Mode �dition ---



        const existing = personnel.find(p => p.id === data.id);



        const userId = existing?.user_id || data.user_id;







        if (userId) {



          await api.users.update(userId, {



            prenom: prenom.trim(),



            nom: nom.trim(),



            poste: data.poste || '�',



            departement_id: departementId || null,



            email: data.email || undefined,



          });



        }







        response = await api.employeesCRUD.update(data.id, {



          contrat: data.contrat || 'CDI',



          heure_limite: data.heureLimite || data.heure_limite || '08:30',



          score_performance: !isNaN(parseFloat(data.score)) ? parseFloat(data.score) : 0,



          color: data.color || '#42a5f5',



        });



        processedEmployee = mapEmployee(response.employee || response);



        setPersonnel(prev => prev.map(p => p.id === data.id ? processedEmployee : p));



        setEmployes(prev => prev.map(p => p.id === data.id ? processedEmployee : p));



      } else {



        // --- Mode cr�ation : tout envoyer en une seule requ�te ---



        const email = data.email || `${prenom.toLowerCase().replace(/\s/g, '')}.${nom.toLowerCase().replace(/\s/g, '')}@fhcgroupe.com`;







        response = await api.completeResources.createEmployeeWithUser({



          prenom: prenom.trim(),



          nom: nom.trim(),



          email: email,



          password: data.password || undefined,



          poste: data.poste || '�',



          departement_id: departementId,





          contrat: data.contrat || 'CDI',



          heure_limite: data.heureLimite || data.heure_limite || '08:30',



          score_performance: !isNaN(parseFloat(data.score)) ? parseFloat(data.score) : 0,



          color: data.color || '#42a5f5',



        });



        processedEmployee = mapEmployee(response.employee || response);



        setPersonnel(prev => [...prev, processedEmployee]);



        setEmployes(prev => [...prev, processedEmployee]);







        if (response.credentials?.email) {



          alert(`? Employ� cr�� !\nEmail: ${response.credentials.email}\nMot de passe: ${response.credentials.password}`);



        }



      }







      closeModal();



      return { success: true, data: processedEmployee };







    } catch (error) {



      console.error('? Erreur savePersonnel:', error);



      alert('Erreur: ' + (error.message || 'Erreur inconnue'));



      return { success: false, error: error.message };



    }



  };







  // --- CORRIG� : Supprime l'Employee ET le User associ� ---



  const deletePersonnel = async (id) => {



    const employee = personnel.find(p => p.id === id);



    if (!employee) return;







    if (!window.confirm(`Supprimer ${employee.nom} ? Cette action est irr�versible.`)) return;







    try {



      await api.employeesCRUD.delete(id);



      // Le backend supprime aussi le User associ�



      setPersonnel(prev => prev.filter(p => p.id !== id));



      setEmployes(prev => prev.filter(p => p.id !== id));



    } catch (error) {



      console.error('? Erreur suppression:', error);



      alert('Erreur lors de la suppression');



    }



  }; // --- CORRIG� : deletePersonnel utilise l'id ---











  const saveFinance = (formData) => {



    const tendanceMap = { green: '?', orange: '?', red: '?', blue: '?' };



    const row = { f: formData.f, ca: formData.ca, pct: formData.pct, t: formData.t || 'green', tb: (tendanceMap[formData.t] || '?') + ' ' + (formData.tb || '') };



    if (formData._isEdit) setFinanceRows(prev => prev.map((r, i) => i === formData._idx ? row : r));



    else setFinanceRows(prev => [...prev, row]);



    closeModal();



  };



  const deleteFinance = idx => setFinanceRows(prev => prev.filter((_, i) => i !== idx));







  // --- CORRIG� : saveDept avec filiale_id ---



  const saveDept = async (formData) => {



    const data = formData || form;



    if (!data.nom) {



      alert('Veuillez saisir le nom du d�partement');



      return;



    }







    try {



      if (data.id && data._isEdit) {



        // Mise � jour via API



        // R�soudre filiale_id : depuis le form, ou depuis le d�partement existant en BDD



        const existingDept = depts.find(d => d.id === data.id);



        const resolvedFilialeId = data.filiale_id



          ? Number(data.filiale_id)



          : existingDept?.filiale_id || null;







        if (!resolvedFilialeId) {



          alert('Veuillez s�lectionner une filiale');



          return;



        }







        const payload = {



          nom: data.nom,



          description: data.desc || data.description || '',



          filiale_id: resolvedFilialeId,



          chef_id: data.chef_id ? Number(data.chef_id) : null,



        };



        const res = await api.departements.update(data.id, payload);



        setDepts(prev => prev.map(d => d.id === data.id ? mapDept(res.departement || res) : d));



      } else {



        // Cr�ation



        let filialeId = 1;



        if (data.filiale_id) {



          filialeId = Number(data.filiale_id);



        } else if (data.filiale) {



          const filObj = filiales.find(f =>



            f.id === Number(data.filiale) ||



            f.nom === data.filiale



          );



          filialeId = filObj?.id ?? 1;



        }







        const payload = {



          nom: data.nom,



          description: data.desc || data.description || '',



          filiale_id: filialeId,



          chef_id: data.chef_id ? Number(data.chef_id) : null,



        };







        console.log('??? Payload d�partement:', payload);







        const res = await api.completeResources.createDepartement(payload);



        if (res.success || res.departement || res.id) {



          setDepts(prev => [...prev, mapDept(res.departement || res)]);



        }



      }



      closeModal();



    } catch (error) {



      console.error('? Erreur d�partement:', error);



      alert('Erreur: ' + (error.message || 'Erreur inconnue'));



    }



  };



  const deleteDept = async (id) => {



    if (!window.confirm('Supprimer ce d�partement ? Cette action est irr�versible.')) return;



    try {



      await api.departements.delete(id);



      setDepts(prev => prev.filter(d => d.id !== id));



    } catch (error) {



      alert('Erreur lors de la suppression: ' + (error.message || 'Erreur inconnue'));



    }



  };







  const saveDecision = (formData) => {  // ? AJOUTER le param�tre (d�j� le cas !)



    const data = formData || form;







    if (!data.text) return;







    if (data._isEdit) {



      setDecisions(prev => prev.map((d, i) => i === data._idx ? { text: data.text, prio: data.prio, statut: data.statut } : d));



    } else {



      setDecisions(prev => [...prev, { text: data.text, prio: data.prio, statut: data.statut }]);



    }



    closeModal();



  };



  const toggleTask = async (t) => {



    try {



      const res = await api.tasks.toggle(t.id);



      setTasks(prev => prev.map(x => x.id === t.id ? mapTask(res.task || res) : x));



    } catch {



      setTasks(prev => prev.map(x => x.id === t.id ? { ...x, done: !x.done } : x));



    }



  };







  const deleteTask = async (id) => {



    try { await api.tasks.update(id, { done: true }); } catch { }



    setTasks(prev => prev.filter(x => x.id !== id));



  };

  // -- CRUD Objectifs ----------------------------------------------------------
  const saveObjectif = async (formData) => {
    try {
      const data = {
        employee_id: formData.employee_id,
        titre: formData.titre,
        description: formData.description || '',
        type_periode: formData.type_periode || 'quotidien',
        date_objectif: formData.date_objectif || null,
        semaine: formData.semaine || null,
        valeur_cible: formData.valeur_cible || null,
        valeur_actuelle: formData.valeur_actuelle || 0,
        deadline: formData.deadline || null,
      };

      if (formData.id) {
        const res = await api.objectifs.update(formData.id, data);
        setObjectifs(prev => prev.map(o => o.id === formData.id ? (res.objectif || res) : o));
      } else {
        const res = await api.objectifs.create(data);
        setObjectifs(prev => [...prev, res.objectif || res]);
      }
      setModal(null);
      setObjectifForm({});
    } catch (error) {
      console.error('Erreur sauvegarde objectif:', error);
      alert('Erreur lors de la sauvegarde de l\'objectif');
    }
  };

  const deleteObjectif = async (id) => {
    if (!window.confirm('Supprimer cet objectif ?')) return;
    try {
      await api.objectifs.delete(id);
      setObjectifs(prev => prev.filter(o => o.id !== id));
    } catch (error) {
      console.error('Erreur suppression objectif:', error);
    }
  };

  const updateObjectifProgression = async (id, progression) => {
    try {
      const res = await api.objectifs.updateProgression(id, progression);
      setObjectifs(prev => prev.map(o => o.id === id ? (res.objectif || res) : o));
    } catch (error) {
      console.error('Erreur mise � jour progression:', error);
    }
  };



  // ?? T�ches du DG uniquement (filtr�es par user.id)



  const dgTasks = tasks.filter(t => !t.employee_id || t.employee_id === user?.id);



  const pendingTasksTotal = dgTasks.filter(t => !t.done).length;



  // KPIs dynamiques



  const kpiProjetsActifs = dashStats.projects_active ?? projets.filter(p => ['en_cours', 'planifie'].includes(p.statut)).length;



  const kpiCollaborateurs = dashStats.total_employees ?? personnel.length;



  const kpiprésents = presenceStats?.employees_present ?? dashStats.employees_present ?? personnel.filter(p => p.present).length;



  const avancementMoyen = projets.length > 0 ? Math.round(projets.reduce((s, p) => s + (p.av || 0), 0) / projets.length) : 0;



  const budgetTotal = projets.reduce((s, p) => s + (Number(p.budget) || 0), 0);



  const depensesTotal = projets.reduce((s, p) => s + (Number(p.dep) || 0), 0);







  const donutItems = filiales.length > 0



    ? filiales.map(f => ({ label: f.nom, val: f.pct || 0, color: f.color }))



    : [];







  if (loading) return <MainLayout><div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '60vh', color: '#C9A84C', fontSize: 16 }}>Chargement du dashboard�</div></MainLayout>;







  return (



    <MainLayout>



      <div className="dashboard-dg-root">







        {/* TOPBAR */}



        <div className="topbar">



          <div className="topbar-left">



            <div className="tlogo">⚡</div>



            <div>



              <div className="tname">FHC Groupe SARL</div>



              <div className="tsub">Plateforme de Gestion Digitale � Dashboard DG</div>



            </div>



          </div>



          <div className="topbar-right">

            <div className="tdate">{formattedDate}</div>

            <button className="tbtn" onClick={() => setNotifOpen(o => !o)}>

              🔔 <span style={{ color: '#ef5350', fontWeight: 700 }}>4</span>

            </button>

            <div style={{ textAlign: 'right' }}>

              <div className="tuser">Directeur Général</div>

              <div className="trole">🔑 Accès total</div>

            </div>

            <div className="tavatar">DG</div>

            <button className="tbtn" onClick={handleLogout} style={{ color: '#ef8080', borderColor: 'rgba(239,83,80,.3)' }}>🚪 Déconnexion</button>

          </div>

        </div>







        {/* LAYOUT */}



        <div className="layout">







          {/* SIDEBAR */}



          <div className="sidebar">



            <div className="sb-logo">Navigation</div>



            {[

              { id: 'vue-globale', icon: '📊', label: 'Vue globale' },

              { id: 'filiales', icon: '🏢', label: 'Filiales' },

              { id: 'departements', icon: '🏢', label: 'Départements', badge: String(depts.length) },

              { id: 'personnel', icon: '👥', label: 'Personnel', badge: String(personnel.length), badgeCls: 'green' },

              { id: 'objectifs', icon: '🎯', label: 'Objectifs', badge: String(objectifs.filter(o => o.statut === 'en_cours').length), badgeCls: 'blue' },

              { id: 'projets', icon: '📁', label: 'Projets', badge: String(projets.length) },

              { id: 'gestion-taches', icon: '✅', label: 'Gestion Tâches', badge: totalTasks > 0 ? String(totalTasks) : '', badgeCls: 'gold' },

              { id: 'vue-departements', icon: '📊', label: 'Vue Departements' },

              { id: 'performance-scores', icon: '⭐', label: 'Performance & Scores', badgeCls: 'gold' },

              { id: 'demandes-permission', icon: '📝', label: 'Demandes Permission', badge: String(demandesPermission.filter(d => d.statut === 'en_attente').length), badgeCls: 'orange' },

            ].map(it => (

              <div key={it.id} className={`sb-item ${activePage === it.id ? 'active' : ''}`} onClick={() => setActivePage(it.id)}>

                <span className="si">{it.icon}</span><span>{it.label}</span>

                {it.badge && <span className={`sb-badge ${it.badgeCls || ''}`}>{it.badge}</span>}

              </div>

            ))}

            <div className="sb-sep" />

            <div className="sb-logo">Pilotage</div>



            {[



              { id: 'finance', icon: '💰', label: 'Finance' },



              { id: 'presence', icon: '✅', label: 'Présence', badge: String(Object.keys(presenceLogs[todayStr] || {}).length || '') },



              { id: 'decisions', icon: '⚖️', label: 'Décisions', badge: String(decisions.filter(d => d.statut !== 'termine').length) },



              { id: 'proces-verbaux', icon: '📋', label: 'Procès-Verbaux' },



              { id: 'agenda', icon: '📅', label: 'Agenda' },



              { id: 'taches', icon: '✔️', label: 'Tâches DG', badge: String(pendingTasksTotal) },



              { id: 'rapports', icon: '📊', label: 'Rapports' },



              { id: 'alertes', icon: '⚠️', label: 'Alertes', badge: '4' },



            ].map(it => (



              <div key={it.id} className={`sb-item ${activePage === it.id ? 'active' : ''}`} onClick={() => setActivePage(it.id)}>



                <span className="si">{it.icon}</span><span>{it.label}</span>



                {it.badge && <span className="sb-badge">{it.badge}</span>}



              </div>



            ))}



            <div className="sb-sep" />



            <div className="sb-logo">Paramètres</div>



            <div className={`sb-item ${activePage === 'parametres' ? 'active' : ''}`} onClick={() => setActivePage('parametres')}>



              <span className="si">⚙️</span><span>Paramètres</span>



            </div>

            <div className="sb-sep" />

            <div className="sb-item" onClick={() => navigate('/documents')}>
              <span className="si">📁</span><span>Documents</span>
            </div>



          </div>







          {/* MAIN */}



          <div className="main">







            {/* --- VUE GLOBALE --- */}



            <div className={`page ${activePage === 'vue-globale' ? 'active' : ''}`}>



              <div className="page-header">

                <div>

                  <div className="page-title">Vue Globale • Tableau de bord</div>

                  <div className="page-sub">Mise à jour en temps réel • Dernière mise à jour {lastUpdate}</div>

                </div>

                <div className="page-actions">

                  <button className="btn-outline" onClick={() => setNow(new Date())}>🔄 Actualiser</button>

                  <button className="btn-gold" onClick={() => { setActivePage('projets'); openModal('projet'); }}>+ Nouveau projet</button>

                </div>

              </div>





              {/* KPIs */}



              <div className="kpi-grid">



                <div className="kpi-card"><div className="kpi-accent" style={{ background: '#C9A84C' }} /><div className="kpi-icon">📁</div><div className="kpi-val">{kpiProjetsActifs}</div><div className="kpi-label">Projets actifs</div><div className="kpi-trend up">📊 total : {projets.length}</div></div>

                <div className="kpi-card"><div className="kpi-accent" style={{ background: '#4caf50' }} /><div className="kpi-icon">👥</div><div className="kpi-val">{kpiCollaborateurs}</div><div className="kpi-label">Collaborateurs</div><div className="kpi-trend neutral">✅ {kpiprésents} présents aujourd'hui</div></div>

                <div className="kpi-card"><div className="kpi-accent" style={{ background: '#42a5f5' }} /><div className="kpi-icon">💰</div><div className="kpi-val">{fmt(budgetTotal) || '0'}</div><div className="kpi-label">Budget projets (FCFA)</div><div className="kpi-trend up">📈 {avancementMoyen}% avanc.</div></div>

                <div className="kpi-card"><div className="kpi-accent" style={{ background: '#ff9800' }} /><div className="kpi-icon">📊</div><div className="kpi-val">{avancementMoyen}%</div><div className="kpi-label">Avancement moyen</div><div className="kpi-trend down">🎯 Cible : 90%</div></div>

              </div>


              {/* Section Filtre de Présence */}
              <PresenceFilterSection
                presenceDate={presenceDateFiltered}
                onDateChange={setPresenceDateFilter}
                stats={presenceStats}
                loading={presenceLoading}
              />


              <div className="grid2">



                <div className="card">



                  <div className="card-title">?? Objectifs 2026 <span className="card-badge">{projets.length} projets</span></div>



                  {projets.slice(0, 4).map(o => (



                    <div key={o.nom} style={{ marginBottom: 14 }}>



                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 5 }}>



                        <span style={{ fontSize: 12, fontWeight: 500, color: '#ccc' }}>{o.nom}</span>



                        <span style={{ fontSize: 11, color: '#667' }}>{o.av}%</span>



                      </div>



                      <Pbar pct={o.av} />



                    </div>



                  ))}



                  {projets.length === 0 && <div style={{ fontSize: 12, color: '#445', fontStyle: 'italic' }}>Aucun projet charg�.</div>}



                </div>



                <div className="card">



                  <AlertesPanel limit={5} />



                </div>



              </div>







              <div className="grid3">



                <div className="card" style={{ gridColumn: 'span 2' }}>



                  <div className="card-title">?? Projets en cours <span className="card-badge">{projets.length} projets</span></div>



                  <table className="tbl">



                    <thead><tr><th>Projet</th><th>Filiale</th><th>Avancement</th><th>Deadline</th><th>Statut</th></tr></thead>



                    <tbody>



                      {projets.map(p => (



                        <tr key={p.id}>



                          <td className="bold">{p.nom}</td>



                          <td>{p.filiale} {p.departement !== '�' ? `� ${p.departement}` : ''}</td>



                          <td style={{ minWidth: 120 }}><Pbar pct={p.av} /></td>



                          <td>{p.deadline_display}</td>



                          <td><Badge statut={p.statut} /></td>



                        </tr>



                      ))}



                    </tbody>



                  </table>



                </div>



                <div className="card">



                  <div className="card-title">?? Pr�sence aujourd'hui</div>



                  <div className="gauge-wrap">



                    <div className="gauge-val">{kpiprésents}/{kpiCollaborateurs}</div>



                    <div className="gauge-label">Collaborateurs présents</div>



                  </div>



                  <div style={{ margin: '12px 0' }}><Pbar pct={kpiCollaborateurs > 0 ? Math.round(kpiprésents / kpiCollaborateurs * 100) : 0} color="#4caf50" /></div>



                  {personnel.slice(0, 5).map(p => (



                    <div key={p.nom} className="pers-item">



                      <div className="pers-av" style={{ background: p.color + '22', color: p.color }}>{p.av}</div>



                      <div><div className="pers-name">{p.nom}</div><div className="pers-role">{p.poste}</div></div>



                      <div className="pers-status">



                        {p.present



                          ? <><span style={{ fontSize: 10, color: '#66bb6a' }}>? Pr�sent</span><span style={{ fontSize: 10, color: '#556' }}>{p.arr}</span></>



                          : <span style={{ fontSize: 10, color: '#ef5350' }}>? Absent</span>}



                      </div>



                    </div>



                  ))}



                </div>



              </div>







              <div className="grid2">



                <div className="card">



                  <div className="card-title">?? R�partition CA par filiale</div>



                  <div className="donut-wrap">



                    <DonutChart items={donutItems} />



                    <div className="donut-legend">



                      {donutItems.map(it => (



                        <div key={it.label} className="legend-item">



                          <div className="legend-dot" style={{ background: it.color }} />



                          <span>{it.label}</span>



                          <span className="legend-val">{it.val}%</span>



                        </div>



                      ))}



                    </div>



                  </div>



                </div>



                <div className="card">



                  <DecisionsPanel limit={5} />



                </div>



              </div>



            </div>







            {/* --- FILIALES --- */}



            <div className={`page ${activePage === 'filiales' ? 'active' : ''}`}>



              <div className="page-header">



                <div><div className="page-title">?? Filiales & Entit�s</div><div className="page-sub">{filiales.length} entit�s actives � FHC Groupe SARL</div></div>



                <button className="btn-gold" onClick={() => openModal('filiale')}>+ Ajouter une filiale</button>



              </div>



              <div className="fil-grid">



                {filiales.map(f => (



                  <div key={f.nom} className="fil-card" onClick={() => setSelectedFiliale(f)} style={{ cursor: 'pointer' }}>



                    <div className="fil-top" style={{ background: f.color }} />



                    <div className="fil-icon">{f.icon}</div>



                    <div className="fil-name">{f.nom}</div>



                    <div className="fil-desc">{f.desc}</div>



                    <Pbar pct={f.pct} color={f.color} />



                    <div className="fil-stat" style={{ marginTop: 8 }}>



                      <span>CA : <span style={{ color: f.color, fontWeight: 600 }}>{f.ca} FCFA</span></span>



                      <Badge statut={f.statut} />



                    </div>



                    <div style={{ display: 'flex', gap: 6, marginTop: 10 }} onClick={e => e.stopPropagation()}>



                      <button className="btn-outline" style={{ flex: 1, padding: '4px 0', fontSize: 11 }} onClick={() => openModal('filiale', { ...f, _isEdit: true, _orig: f.nom })}>?? Modifier</button>



                      <button className="btn-outline" style={{ padding: '4px 10px', fontSize: 11, color: '#ef5350' }} onClick={() => deleteFiliale(f.nom)}>???</button>



                    </div>



                  </div>



                ))}



              </div>



              <SecTitle>Performance consolid�e</SecTitle>



              <div className="card">



                <table className="tbl">



                  <thead><tr><th>Filiale</th><th>Projets actifs</th><th>CA estim�</th><th>Objectif</th><th>Progression</th><th>Statut</th></tr></thead>



                  <tbody>



                    {filiales.map(f => (



                      <tr key={f.nom}>



                        <td className="bold">{f.icon} {f.nom}</td>



                        <td style={{ textAlign: 'center' }}>{f.projets}</td>



                        <td>{f.ca} FCFA</td>



                        <td>{f.obj} FCFA</td>



                        <td style={{ minWidth: 100 }}><Pbar pct={f.pct} color={f.color} /></td>



                        <td><Badge statut={f.statut} /></td>



                      </tr>



                    ))}



                  </tbody>



                </table>



              </div>



            </div>







            {/* --- PERSONNEL --- */}



            <div className={`page ${activePage === 'personnel' ? 'active' : ''}`}>

              {(() => {

                const HEURE_LIMITE = '08:30';

                const isRetard = arr => arr && arr !== '—' && arr > HEURE_LIMITE;

                // 🔧 UTILISER EXCLUSIVEMENT les stats de l'API avec 3 catégories
                const statsAPI = presenceStats || {};
                const totalEmployees = statsAPI.total_employees || 0;      // Total employés valides
                const employeesOnTime = statsAPI.employees_on_time || 0;   // À l'heure (statut 'ok')
                const retardsCount = statsAPI.retards || 0;                // En retard (statut 'retard')
                const employeesPresent = statsAPI.employees_present || 0;  // Total présents (ok + retard)
                const employeesAbsent = statsAPI.employees_absent || 0;    // Absents (Total - Présents)
                const isToday = presenceDateFiltered === todayStr;

                // Pour l'affichage des détails des employés dans le tableau
                const présents = personnelDuJour.filter(p => p.present);
                const retards = personnelDuJour.filter(p => p.present && isRetard(p.arr));
                const absents = personnelDuJour.filter(p => !p.present);

                // Taux d'accomplissement des tâches
                const tauxAccomp = personnelDuJour.filter(p => p.taches > 0).reduce((s, p) => s + Math.round(p.done / p.taches * 100), 0) / (personnelDuJour.filter(p => p.taches > 0).length || 1);

                return (

                  <>

                    <div className="page-header">

                      <div>

                        <div className="page-title">👥 Personnel • Vue DG</div>

                        <div className="page-sub">
                          Total : {totalEmployees} employés • Heure limite : 08h30 • 
                          {isToday ? ' Données en temps réel' : ' Données historiques'}
                        </div>

                      </div>

                      <div className="page-actions">

                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>

                          <span style={{ fontSize: 11, color: '#667' }}>📅 Date :</span>

                          <input 
                            type="date" 
                            value={presenceDateFiltered} 
                            onChange={e => setPresenceDateFilter(e.target.value)}
                            max={todayStr}
                            style={{ background: '#0d1b2a', border: '1px solid rgba(255,255,255,.15)', borderRadius: 8, padding: '6px 10px', color: '#fff', fontFamily: 'inherit', fontSize: 12, outline: 'none' }} 
                          />
                          {isToday && <span style={{ fontSize: 10, background: 'linear-gradient(135deg, #C9A84C 0%, #f0c14b 100%)', color: '#0d1b2a', padding: '3px 8px', borderRadius: 10, fontWeight: 700 }}>📍 AUJOURD'HUI</span>}
                        </div>

                        <button className="btn-outline">📥 Exporter</button>

                        <button className="btn-gold" onClick={() => openModal('personnel', { present: 'true', color: '#C9A84C' })}>+ Nouveau collaborateur</button>

                      </div>

                    </div>

                    {presenceLoading ? (
                      <div style={{ textAlign: 'center', padding: '40px', color: '#667' }}>
                        <div style={{ marginBottom: '10px', fontSize: '32px' }}>⏳</div>
                        <div style={{ fontSize: '14px', fontWeight: 600 }}>Chargement des données de présence...</div>
                        <div style={{ fontSize: '11px', marginTop: '6px' }}>Veuillez patienter</div>
                      </div>
                    ) : (
                      <>
                        {/* Affichage de la formule de calcul */}
                        <div style={{ background: 'rgba(66,165,245,.08)', border: '1px dashed rgba(66,165,245,.25)', borderRadius: 10, padding: '12px 16px', marginBottom: 16, textAlign: 'center' }}>
                          <div style={{ fontSize: 11, color: '#95a3b3', fontFamily: "'Courier New', monospace" }}>
                            <strong>Formule :</strong> Absents = Total - (À l'heure + En retard) = {totalEmployees} - ({employeesOnTime} + {retardsCount}) = {employeesAbsent}
                          </div>
                        </div>

                        {/* KPI Cards - 3 catégories distinctes */}
                        <div className="kpi-grid" style={{ gridTemplateColumns: 'repeat(4, 1fr)' }}>

                          {/* Total employés */}
                          <div className="kpi-card" style={{ background: 'rgba(66, 165, 245, 0.05)', borderLeft: '3px solid #42a5f5' }}>
                            <div className="kpi-accent" style={{ background: '#42a5f5' }} />
                            <div className="kpi-icon">👥</div>
                            <div className="kpi-val" style={{ color: '#42a5f5' }}>{totalEmployees}</div>
                            <div className="kpi-label">Total Employés</div>
                            <div className="kpi-trend" style={{ color: '#95a3b3' }}>
                              Employés valides
                            </div>
                          </div>

                          {/* À l'heure */}
                          <div className="kpi-card" style={{ background: 'rgba(76, 175, 80, 0.05)', borderLeft: '3px solid #4caf50' }}>
                            <div className="kpi-accent" style={{ background: '#4caf50' }} />
                            <div className="kpi-icon">✅</div>
                            <div className="kpi-val" style={{ color: '#4caf50' }}>{employeesOnTime}</div>
                            <div className="kpi-label">À l'heure</div>
                            <div className="kpi-trend up">
                              {totalEmployees > 0 ? `${Math.round((employeesOnTime / totalEmployees) * 100)}%` : '0%'} du personnel
                            </div>
                          </div>

                          {/* En retard */}
                          <div className="kpi-card" style={{ background: 'rgba(255, 152, 0, 0.05)', borderLeft: '3px solid #ff9800' }}>
                            <div className="kpi-accent" style={{ background: '#ff9800' }} />
                            <div className="kpi-icon">⏰</div>
                            <div className="kpi-val" style={{ color: '#ff9800' }}>{retardsCount}</div>
                            <div className="kpi-label">En retard</div>
                            <div className={`kpi-trend ${retardsCount > 0 ? 'down' : 'up'}`}>
                              {retardsCount > 0 ? `⚠️ ${Math.round((retardsCount / totalEmployees) * 100)}%` : '✅ Aucun retard'}
                            </div>
                          </div>

                          {/* Absents */}
                          <div className="kpi-card" style={{ background: 'rgba(239, 83, 80, 0.05)', borderLeft: '3px solid #ef5350' }}>
                            <div className="kpi-accent" style={{ background: '#ef5350' }} />
                            <div className="kpi-icon">❌</div>
                            <div className="kpi-val" style={{ color: '#ef5350' }}>{employeesAbsent}</div>
                            <div className="kpi-label">Absents</div>
                            <div className="kpi-trend down">
                              {totalEmployees > 0 ? `${Math.round((employeesAbsent / totalEmployees) * 100)}%` : '0%'} non pointés
                            </div>
                          </div>

                        </div>

                        {/* Message pour données historiques */}
                        {!isToday && (
                          <div style={{ background: 'rgba(66,165,245,.08)', border: '1px solid rgba(66,165,245,.25)', borderRadius: 10, padding: '12px 16px', marginBottom: 16, display: 'flex', alignItems: 'center', gap: 10 }}>
                            <span style={{ fontSize: 16 }}>ℹ️</span>
                            <div>
                              <div style={{ fontSize: 12, fontWeight: 600, color: '#64b5f6' }}>Données historiques</div>
                              <div style={{ fontSize: 11, color: '#667', marginTop: 2 }}>
                                Les informations proviennent des pointages enregistrés pour le {presenceDateFiltered}
                              </div>
                            </div>
                          </div>
                        )}

                        {/* Alerte retards pour aujourd'hui */}
                        {retardsCount > 0 && isToday && (
                          <div style={{ background: 'rgba(255, 152, 0, 0.08)', border: '1px solid rgba(255, 152, 0, 0.25)', borderRadius: 10, padding: '12px 16px', marginBottom: 16, display: 'flex', alignItems: 'center', gap: 10 }}>
                            <span style={{ fontSize: 16 }}>⚠️</span>
                            <div>
                              <div style={{ fontSize: 12, fontWeight: 600, color: '#ff9800' }}>
                                {retardsCount} retard{retardsCount > 1 ? 's' : ''} détecté{retardsCount > 1 ? 's' : ''} ce jour (après 08h30)
                              </div>
                              <div style={{ fontSize: 11, color: '#667', marginTop: 2 }}>
                                {retards.slice(0, 5).map(p => `${p.nom} (${p.arr})`).join(' • ')}
                                {retards.length > 5 && ` • +${retards.length - 5} autres`}
                              </div>
                            </div>
                          </div>
                        )}

                        {/* Alerte absents pour aujourd'hui */}
                        {employeesAbsent > 0 && isToday && (
                          <div style={{ background: 'rgba(239, 83, 80, 0.08)', border: '1px solid rgba(239, 83, 80, 0.25)', borderRadius: 10, padding: '12px 16px', marginBottom: 16, display: 'flex', alignItems: 'center', gap: 10 }}>
                            <span style={{ fontSize: 16 }}>📢</span>
                            <div>
                              <div style={{ fontSize: 12, fontWeight: 600, color: '#ef5350' }}>
                                {employeesAbsent} employé{employeesAbsent > 1 ? 's' : ''} absent{employeesAbsent > 1 ? 's' : ''} (sans pointage)
                              </div>
                              <div style={{ fontSize: 11, color: '#667', marginTop: 2 }}>
                                {absents.slice(0, 5).map(p => p.nom).join(' • ')}
                                {absents.length > 5 && ` • +${absents.length - 5} autres`}
                              </div>
                            </div>
                          </div>
                        )}
                      </>
                    )}


                    <SecTitle>Collaborateurs & productivité • {isToday ? "Aujourd'hui" : presenceDateFiltered}</SecTitle>

                    <div className="card">

                      <table className="tbl">

                        <thead>

                          <tr>

                            <th>Collaborateur</th>

                            <th>Poste</th>

                            <th>Département</th>

                            <th>Arrivée</th>

                            <th>Fin</th>

                            <th>Statut présence</th>

                            <th>Tâches</th>

                            <th>Accomplissement</th>

                            <th>Travail équipe</th>

                            <th>Respect règles</th>

                            <th>Actions</th>

                          </tr>

                        </thead>

                        <tbody>

                          {personnelDuJour.map(p => {

                            const retard = p.present && isRetard(p.arr);

                            return (

                              <tr key={p.id || p.nom}>

                                <td>

                                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>

                                    <div style={{ width: 28, height: 28, borderRadius: '50%', background: p.color + '22', color: p.color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 10, fontWeight: 700 }}>{p.av}</div>

                                    <span className="bold">{p.prenom} {p.nom}</span>

                                  </div>

                                </td>

                                <td>{p.poste || '—'}</td>

                                <td>{p.dept || p.departement || p.filiale || '—'}</td>

                                <td>

                                  <span style={{ color: !p.present ? '#ef5350' : retard ? '#ffb74d' : '#66bb6a', fontWeight: 600 }}>

                                    {p.arr || '—'}

                                  </span>

                                </td>

                                <td>

                                  <span style={{ color: !p.present ? '#999' : '#333', fontWeight: 500 }}>

                                    {p.fin || '—'}

                                  </span>

                                </td>

                                <td>

                                  {!p.present

                                    ? <span className="badge red">Absent</span>

                                    : retard

                                      ? <span className="badge orange">⏰ Retard</span>

                                      : <span className="badge green">✅ À l'heure</span>}

                                </td>

                                <td>{p.tachesDone || 0}/{p.tachesQuot || 0} tâches</td>

                                <td style={{ minWidth: 90 }}>{(p.tachesQuot || 0) > 0 ? <Pbar pct={Math.round((p.tachesDone || 0) / (p.tachesQuot || 1) * 100)} /> : '—'}</td>

                                <td style={{ textAlign: 'center' }}>

                                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>

                                    <span style={{ color: (p.score_travail_equipe || 0) >= 70 ? '#66bb6a' : (p.score_travail_equipe || 0) >= 50 ? '#ffb74d' : (p.score_travail_equipe || 0) > 0 ? '#ef5350' : '#667', fontWeight: 600, fontSize: 12 }}>

                                      {p.score_travail_equipe || '—'}

                                    </span>

                                    {(p.score_travail_equipe || 0) > 0 && <span style={{ fontSize: 9, color: '#556' }}>/100</span>}

                                  </div>

                                </td>

                                <td style={{ textAlign: 'center' }}>

                                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>

                                    <span style={{ color: (p.score_respect_regles || 0) >= 70 ? '#66bb6a' : (p.score_respect_regles || 0) >= 50 ? '#ffb74d' : (p.score_respect_regles || 0) > 0 ? '#ef5350' : '#667', fontWeight: 600, fontSize: 12 }}>

                                      {p.score_respect_regles || '—'}

                                    </span>

                                    {(p.score_respect_regles || 0) > 0 && <span style={{ fontSize: 9, color: '#556' }}>/100</span>}

                                  </div>

                                </td>

                                <td style={{ display: 'flex', gap: 4 }}>

                                  <button className="btn-outline" style={{ padding: '4px 8px', fontSize: 11 }} onClick={() => openModal('personnel', { ...p, present: String(p.present), _isEdit: true, _orig: p.nom })}>✏️</button>

                                  <button className="btn-outline" style={{ padding: '4px 8px', fontSize: 11, color: '#ef5350' }} onClick={() => deletePersonnel(p.id)}>🗑️</button>

                                </td>

                              </tr>

                            );

                          })}

                        </tbody>

                      </table>

                    </div>


                  </>



                );



              })()}



            </div>

            {/* --- OBJECTIFS --- */}
            <div className={`page ${activePage === 'objectifs' ? 'active' : ''}`}>
              <div className="page-header">
                <div>
                  <div className="page-title">?? Gestion des Objectifs</div>
                  <div className="page-sub">Objectifs quotidiens et hebdomadaires par employ�</div>
                </div>
                <button className="btn-gold" onClick={() => { setObjectifForm({}); setModal('objectif'); }}>
                  + Nouvel objectif
                </button>
              </div>

              {/* Filtres */}
              <div style={{ display: 'flex', gap: 16, marginBottom: 24, flexWrap: 'wrap', alignItems: 'center' }}>
                <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                  <label style={{ fontSize: 13, color: '#889', fontWeight: 600 }}>P�riode:</label>
                  <select
                    value={objectifFilters.type_periode}
                    onChange={(e) => setObjectifFilters({ ...objectifFilters, type_periode: e.target.value })}
                    style={{ padding: '6px 12px', borderRadius: 6, border: '1px solid #ddd', fontSize: 13 }}
                  >
                    <option value="">Tous</option>
                    <option value="quotidien">Quotidien</option>
                    <option value="hebdomadaire">Hebdomadaire</option>
                    <option value="mensuel">Mensuel</option>
                    <option value="annuel">Annuel</option>
                  </select>
                </div>

                {objectifFilters.type_periode === 'quotidien' && (
                  <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                    <label style={{ fontSize: 13, color: '#889', fontWeight: 600 }}>Date:</label>
                    <input
                      type="date"
                      value={objectifFilters.date_objectif || ''}
                      onChange={(e) => setObjectifFilters({ ...objectifFilters, date_objectif: e.target.value })}
                      style={{ padding: '6px 12px', borderRadius: 6, border: '1px solid #ddd', fontSize: 13 }}
                    />
                    <button
                      onClick={() => setObjectifFilters({ ...objectifFilters, date_objectif: '' })}
                      style={{ padding: '6px 12px', borderRadius: 6, border: '1px solid #ddd', fontSize: 11, background: '#f5f5f5', cursor: 'pointer' }}
                    >
                      R�initialiser
                    </button>
                  </div>
                )}

                {objectifFilters.type_periode === 'hebdomadaire' && (
                  <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                    <label style={{ fontSize: 13, color: '#889', fontWeight: 600 }}>Semaine:</label>
                    <input
                      type="week"
                      value={objectifFilters.semaine || ''}
                      onChange={(e) => setObjectifFilters({ ...objectifFilters, semaine: e.target.value })}
                      style={{ padding: '6px 12px', borderRadius: 6, border: '1px solid #ddd', fontSize: 13 }}
                    />
                    <button
                      onClick={() => setObjectifFilters({ ...objectifFilters, semaine: '' })}
                      style={{ padding: '6px 12px', borderRadius: 6, border: '1px solid #ddd', fontSize: 11, background: '#f5f5f5', cursor: 'pointer' }}
                    >
                      R�initialiser
                    </button>
                  </div>
                )}

                <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                  <label style={{ fontSize: 13, color: '#889', fontWeight: 600 }}>Employ�:</label>
                  <select
                    value={objectifFilters.employee_id || ''}
                    onChange={(e) => setObjectifFilters({ ...objectifFilters, employee_id: e.target.value })}
                    style={{ padding: '6px 12px', borderRadius: 6, border: '1px solid #ddd', fontSize: 13, minWidth: 200 }}
                  >
                    <option value="">Tous les employ�s</option>
                    {personnel.map(emp => (
                      <option key={emp.id} value={emp.id}>{emp.nom}</option>
                    ))}
                  </select>
                </div>
              </div>

              {/* KPIs */}
              <div className="kpi-grid" style={{ marginBottom: 24 }}>
                <div className="kpi-card">
                  <div className="kpi-accent" style={{ background: '#4caf50' }} />
                  <div className="kpi-icon">?</div>
                  <div className="kpi-val">{objectifs.filter(o => o.statut === 'atteint').length}</div>
                  <div className="kpi-label">Objectifs atteints</div>
                </div>
                <div className="kpi-card">
                  <div className="kpi-accent" style={{ background: '#ff9800' }} />
                  <div className="kpi-icon">??</div>
                  <div className="kpi-val">{objectifs.filter(o => o.statut === 'en_cours').length}</div>
                  <div className="kpi-label">En cours</div>
                </div>
                <div className="kpi-card">
                  <div className="kpi-accent" style={{ background: '#ef5350' }} />
                  <div className="kpi-icon">??</div>
                  <div className="kpi-val">{objectifs.filter(o => o.statut === 'retard').length}</div>
                  <div className="kpi-label">En retard</div>
                </div>
                <div className="kpi-card">
                  <div className="kpi-accent" style={{ background: '#42a5f5' }} />
                  <div className="kpi-icon">??</div>
                  <div className="kpi-val">
                    {objectifs.length > 0 ? Math.round(objectifs.reduce((sum, o) => sum + (o.progression || 0), 0) / objectifs.length) : 0}%
                  </div>
                  <div className="kpi-label">Progression moyenne</div>
                </div>
              </div>

              {/* Liste des objectifs en cartes */}
              {objectifs.length === 0 ? (
                <div className="card" style={{ padding: '48px 32px', textAlign: 'center' }}>
                  <div style={{ fontSize: 48, marginBottom: 16, opacity: 0.5 }}>??</div>
                  <div style={{ fontSize: 15, color: '#889', marginBottom: 8 }}>Aucun objectif trouv�</div>
                  <div style={{ fontSize: 13, color: '#667' }}>Cliquez sur "+ Nouvel objectif" pour en cr�er un.</div>
                </div>
              ) : (
                <div style={{ display: 'grid', gap: 20 }}>
                  {objectifs.map(obj => {
                    const emp = personnel.find(p => p.id === obj.employee_id);
                    const empNom = emp ? emp.nom : obj.employee?.user ? `${obj.employee.user.prenom} ${obj.employee.user.nom}` : '�';
                    const progressionColor = obj.progression >= 100 ? '#66bb6a' : obj.progression >= 75 ? '#C9A84C' : obj.progression >= 50 ? '#42a5f5' : '#ef8080';
                    
                    return (
                      <div 
                        key={obj.id} 
                        className="card"
                        style={{ 
                          padding: 0,
                          overflow: 'hidden',
                          transition: 'all 0.3s ease',
                          border: '1px solid rgba(255,255,255,.06)'
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.borderColor = 'rgba(201,168,76,.3)';
                          e.currentTarget.style.transform = 'translateY(-2px)';
                          e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,.3)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.borderColor = 'rgba(255,255,255,.06)';
                          e.currentTarget.style.transform = 'translateY(0)';
                          e.currentTarget.style.boxShadow = 'none';
                        }}
                      >
                        {/* Barre sup�rieure color�e selon la progression */}
                        <div style={{ 
                          height: 4, 
                          background: `linear-gradient(90deg, ${progressionColor} ${obj.progression || 0}%, rgba(255,255,255,.05) ${obj.progression || 0}%)` 
                        }} />
                        
                        <div style={{ padding: '24px 28px' }}>
                          {/* En-t�te avec employ� et badges */}
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20, gap: 16 }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                              {emp && (
                                <div className="avatar" style={{ background: emp.color, fontSize: 13, width: 40, height: 40, flexShrink: 0 }}>
                                  {emp.av}
                                </div>
                              )}
                              <div>
                                <div style={{ fontSize: 13, fontWeight: 600, color: '#C9A84C', marginBottom: 2 }}>{empNom}</div>
                                <div style={{ fontSize: 11, color: '#889' }}>
                                  {emp?.departement || 'D�partement non sp�cifi�'}
                                </div>
                              </div>
                            </div>
                            <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexShrink: 0 }}>
                              <span className="badge" style={{ 
                                background: obj.type_periode === 'quotidien' ? '#e3f2fd' : obj.type_periode === 'hebdomadaire' ? '#fff3e0' : obj.type_periode === 'mensuel' ? '#f3e5f5' : '#e8f5e9',
                                color: obj.type_periode === 'quotidien' ? '#1976d2' : obj.type_periode === 'hebdomadaire' ? '#f57c00' : obj.type_periode === 'mensuel' ? '#7b1fa2' : '#2e7d32',
                                padding: '6px 12px',
                                fontSize: 11,
                                fontWeight: 600
                              }}>
                                {obj.type_periode === 'quotidien' ? '?? Quotidien' :
                                 obj.type_periode === 'hebdomadaire' ? '?? Hebdo' :
                                 obj.type_periode === 'mensuel' ? '?? Mensuel' : '??? Annuel'}
                              </span>
                              <Badge statut={obj.statut} />
                            </div>
                          </div>

                          {/* Titre et description */}
                          <div style={{ marginBottom: 20 }}>
                            <div style={{ fontSize: 16, fontWeight: 600, color: '#fff', marginBottom: 6, lineHeight: 1.4 }}>
                              ?? {obj.titre}
                            </div>
                            {obj.description && (
                              <div style={{ fontSize: 12, color: '#aab', lineHeight: 1.6 }}>
                                {obj.description}
                              </div>
                            )}
                          </div>

                          {/* Grille d'indicateurs */}
                          <div style={{ 
                            display: 'grid', 
                            gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', 
                            gap: 16, 
                            marginBottom: 20,
                            padding: '16px 0',
                            borderTop: '1px solid rgba(255,255,255,.06)',
                            borderBottom: '1px solid rgba(255,255,255,.06)'
                          }}>
                            {obj.valeur_cible && (
                              <div style={{ textAlign: 'center' }}>
                                <div style={{ fontSize: 10, color: '#778', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '.8px', fontWeight: 600 }}>
                                  ?? Cible
                                </div>
                                <div style={{ fontSize: 20, fontWeight: 600, color: '#C9A84C', fontFamily: "'Cormorant Garamond',serif" }}>
                                  {obj.valeur_cible}
                                </div>
                              </div>
                            )}
                            {(obj.valeur_actuelle !== null && obj.valeur_actuelle !== undefined) && (
                              <div style={{ textAlign: 'center' }}>
                                <div style={{ fontSize: 10, color: '#778', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '.8px', fontWeight: 600 }}>
                                  ?? Actuel
                                </div>
                                <div style={{ fontSize: 20, fontWeight: 600, color: '#fff', fontFamily: "'Cormorant Garamond',serif" }}>
                                  {obj.valeur_actuelle}
                                </div>
                              </div>
                            )}
                            <div style={{ textAlign: 'center' }}>
                              <div style={{ fontSize: 10, color: '#778', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '.8px', fontWeight: 600 }}>
                                ?? Progression
                              </div>
                              <div style={{ fontSize: 20, fontWeight: 600, color: progressionColor, fontFamily: "'Cormorant Garamond',serif" }}>
                                {obj.progression || 0}%
                              </div>
                            </div>
                            {obj.deadline && (
                              <div style={{ textAlign: 'center' }}>
                                <div style={{ fontSize: 10, color: '#778', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '.8px', fontWeight: 600 }}>
                                  ? �ch�ance
                                </div>
                                <div style={{ fontSize: 12, fontWeight: 600, color: '#889' }}>
                                  {new Date(obj.deadline).toLocaleDateString('fr-FR', { day: '2-digit', month: 'short', year: 'numeric' })}
                                </div>
                              </div>
                            )}
                          </div>

                          {/* Barre de progression am�lior�e */}
                          <div style={{ marginBottom: 20 }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8, fontSize: 11 }}>
                              <span style={{ color: '#889', fontWeight: 600 }}>Avancement</span>
                              <span style={{ color: progressionColor, fontWeight: 700 }}>{obj.progression || 0}%</span>
                            </div>
                            <Pbar pct={obj.progression || 0} />
                          </div>

                          {/* Actions */}
                          <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
                            <button
                              className="btn-outline"
                              style={{ 
                                padding: '8px 16px', 
                                fontSize: 12,
                                display: 'flex',
                                alignItems: 'center',
                                gap: 6,
                                fontWeight: 600
                              }}
                              onClick={() => { setObjectifForm(obj); setModal('objectif'); }}
                              title="Modifier l'objectif"
                            >
                              ?? Modifier
                            </button>
                            <button
                              className="btn-outline"
                              style={{ 
                                padding: '8px 16px', 
                                fontSize: 12, 
                                color: '#ef5350',
                                borderColor: 'rgba(239, 83, 80, 0.3)',
                                display: 'flex',
                                alignItems: 'center',
                                gap: 6,
                                fontWeight: 600
                              }}
                              onClick={() => deleteObjectif(obj.id)}
                              title="Supprimer l'objectif"
                            >
                              ??? Supprimer
                            </button>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>







            {/* --- PROJETS --- */}



            <div className={`page ${activePage === 'projets' ? 'active' : ''}`}>



              <div className="page-header">



                <div><div className="page-title">?? Portefeuille Projets</div><div className="page-sub">Suivi complet � Budget � Avancement � �quipe</div></div>



                <button className="btn-gold" onClick={() => openModal('projet')}>+ Nouveau projet</button>



              </div>



              <div className="kpi-grid">



                <div className="kpi-card"><div className="kpi-accent" style={{ background: '#42a5f5' }} /><div className="kpi-icon">??</div><div className="kpi-val">{projets.length}</div><div className="kpi-label">Projets total</div></div>



                <div className="kpi-card"><div className="kpi-accent" style={{ background: '#C9A84C' }} /><div className="kpi-icon">??</div><div className="kpi-val">{fmt(budgetTotal)}</div><div className="kpi-label">Budget total (FCFA)</div></div>



                <div className="kpi-card"><div className="kpi-accent" style={{ background: '#ff9800' }} /><div className="kpi-icon">??</div><div className="kpi-val">{fmt(depensesTotal)}</div><div className="kpi-label">D�penses cumul�es</div></div>



                <div className="kpi-card"><div className="kpi-accent" style={{ background: '#4caf50' }} /><div className="kpi-icon">??</div><div className="kpi-val">{avancementMoyen}%</div><div className="kpi-label">Avancement moyen</div></div>



              </div>



              <SecTitle>D�tail des projets</SecTitle>



              {projets.map(p => (



                <div key={p.id} className="card" style={{ marginBottom: 12, cursor: 'pointer' }} onClick={() => setSelectedProjet(p)}>



                  <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 12 }}>



                    <div>



                      <div style={{ fontSize: 14, fontWeight: 600, color: '#fff', marginBottom: 4 }}>{p.nom}</div>



                      <div style={{ fontSize: 11, color: '#667' }}>



                        {p.filiale} {p.departement !== '�' ? `� ${p.departement}` : ''}



                        � Resp : {p.resp}



                        � Deadline : {p.deadline_display}



                      </div>



                    </div>



                    <div style={{ display: 'flex', gap: 8, alignItems: 'center' }} onClick={e => e.stopPropagation()}>



                      <Badge statut={p.statut} />



                      <button



                        className="btn-outline"



                        style={{ padding: '4px 10px', fontSize: 11 }}



                        onClick={(e) => {



                          e.stopPropagation();



                          const filialeId = p.filiale_id;



                          setProjetFilialeId(filialeId);



                          openModal('projet', {



                            ...p,



                            _isEdit: true,



                            _id: p._id,



                            nom: p.nom,



                            filiale_id: filialeId ? String(filialeId) : '',



                            departement_id: p.departement_id ? String(p.departement_id) : '',



                            resp_id: p.resp_id ? String(p.resp_id) : '',



                            equipe: (p.equipe || []).map(String),



                            deadline: p.deadline,



                            statut: p.statut,



                            av: p.av,



                            budget: p.budget,



                            description: p.description,



                          });



                        }}



                      >



                        ??



                      </button>



                      <button className="btn-outline" style={{ padding: '4px 10px', fontSize: 11, color: '#ef5350' }} onClick={(e) => { e.stopPropagation(); deleteProjet(p); }}>???</button>



                    </div>



                  </div>



                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 2fr', gap: 12, alignItems: 'center' }}>



                    <div><div style={{ fontSize: 10, color: '#556', marginBottom: 3 }}>Budget</div><div style={{ fontSize: 13, fontWeight: 600 }}>{fmt(p.budget)} FCFA</div></div>



                    <div><div style={{ fontSize: 10, color: '#556', marginBottom: 3 }}>D�penses</div><div style={{ fontSize: 13, fontWeight: 600 }}>{fmt(p.dep)} FCFA</div></div>



                    <div>



                      <div style={{ fontSize: 10, color: '#556', marginBottom: 3 }}>�quipe</div>



                      <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>



                        {(p.equipe_noms || []).map((nom, i) => (



                          <div key={i} style={{



                            padding: '2px 8px',



                            background: 'rgba(201,168,76,.15)',



                            color: '#C9A84C',



                            borderRadius: 99,



                            fontSize: 10,



                            fontWeight: 600



                          }}>



                            {nom}



                          </div>



                        ))}



                        {p.equipe_noms?.length === 0 && (



                          <span style={{ fontSize: 11, color: '#556', fontStyle: 'italic' }}>



                            Aucun membre



                          </span>



                        )}



                      </div>



                    </div>



                    <div><div style={{ fontSize: 10, color: '#556', marginBottom: 5 }}>Avancement : {p.av}%</div><Pbar pct={p.av} /></div>



                  </div>



                </div>



              ))}



            </div>







            {/* --- FINANCE --- */}



            <div className={`page ${activePage === 'finance' ? 'active' : ''}`}>



              <div className="page-header">



                <div><div className="page-title">?? Finance & Budget</div><div className="page-sub">Exercice 2026 � Mise � jour mensuelle</div></div>



                <button className="btn-gold">?? Rapport financier</button>



              </div>



              <div className="kpi-grid">



                <div className="kpi-card"><div className="kpi-accent" style={{ background: '#4caf50' }} /><div className="kpi-icon">??</div><div className="kpi-val">{fmt(budgetTotal)}</div><div className="kpi-label">Budget projets (FCFA)</div><div className="kpi-trend up">? donn�es r�elles</div></div>



                <div className="kpi-card"><div className="kpi-accent" style={{ background: '#ef5350' }} /><div className="kpi-icon">??</div><div className="kpi-val">{fmt(depensesTotal)}</div><div className="kpi-label">D�penses totales (FCFA)</div><div className="kpi-trend neutral">? Budget ma�tris�</div></div>



                <div className="kpi-card"><div className="kpi-accent" style={{ background: '#42a5f5' }} /><div className="kpi-icon">??</div><div className="kpi-val">{kpiProjetsActifs}</div><div className="kpi-label">Projets actifs</div><div className="kpi-trend up">? sur {projets.length} total</div></div>



                <div className="kpi-card"><div className="kpi-accent" style={{ background: '#ff9800' }} /><div className="kpi-icon">??</div><div className="kpi-val">{avancementMoyen}%</div><div className="kpi-label">Avancement moyen</div><div className="kpi-trend neutral">? Objectif : 100%</div></div>



              </div>



              <div className="grid2">



                <div className="card">



                  <div className="card-title">?? CA mensuel 2026</div>



                  <CAChart rows={financeRows} />



                </div>



                <div className="card">



                  <div className="card-title">?? CA par filiale



                    <button className="btn-gold" style={{ fontSize: 11, padding: '4px 12px' }} onClick={() => openModal('finance')}>+ Ajouter</button>



                  </div>



                  <table className="tbl">



                    <thead><tr><th>Filiale</th><th>CA r�alis�</th><th>% du total</th><th>Tendance</th><th>Actions</th></tr></thead>



                    <tbody>



                      {financeRows.map((r, i) => (



                        <tr key={i}>



                          <td className="bold">{r.f}</td>



                          <td>{r.ca}</td>



                          <td>{r.pct}</td>



                          <td><span className={`badge ${r.t}`}>{r.tb}</span></td>



                          <td style={{ display: 'flex', gap: 4 }}>



                            <button className="btn-outline" style={{ padding: '3px 8px', fontSize: 11 }} onClick={() => openModal('finance', { ...r, _isEdit: true, _idx: i })}>??</button>



                            <button className="btn-outline" style={{ padding: '3px 8px', fontSize: 11, color: '#ef5350' }} onClick={() => deleteFinance(i)}>???</button>



                          </td>



                        </tr>



                      ))}



                    </tbody>



                  </table>



                </div>



              </div>



            </div>







            {/* --- PR�SENCE --- */}



            <div className={`page ${activePage === 'presence' ? 'active' : ''}`}>



              <div className="page-header">



                <div>



                  <div className="page-title">?? Pr�sence & Pointage</div>



                  <div className="page-sub">Suivi journalier � Validation par code</div>



                </div>



              </div>







              <div className="grid2" style={{ marginBottom: 0 }}>



                <div className="card">



                  <div className="card-title">?? G�n�ration du code de pr�sence



                    <span className="card-badge">DG uniquement</span>



                  </div>



                  <div style={{ marginBottom: 12 }}>



                    <label style={{ fontSize: 10, color: '#667', textTransform: 'uppercase', letterSpacing: '.8px', display: 'block', marginBottom: 5 }}>Date cible (g�n�rer la veille)</label>



                    <input type="date" value={codeTargetDate} onChange={e => setCodeTargetDate(e.target.value)}



                      style={{ background: '#0d1b2a', border: '1px solid rgba(255,255,255,.15)', borderRadius: 8, padding: '9px 12px', color: '#fff', fontFamily: 'inherit', fontSize: 13, outline: 'none', width: '100%' }} />



                  </div>



                  <button className="btn-gold" style={{ width: '100%', marginBottom: 16 }} onClick={generateCode}>



                    ⚡ G�n�rer le code pour le {codeTargetDate}



                  </button>



                  {presenceCodes[codeTargetDate] && (



                    <div style={{ background: 'rgba(201,168,76,.1)', border: '1px solid rgba(201,168,76,.3)', borderRadius: 10, padding: '16px', textAlign: 'center' }}>



                      <div style={{ fontSize: 10, color: '#889', marginBottom: 6 }}>CODE DU {codeTargetDate}</div>



                      <div style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 42, fontWeight: 700, color: '#C9A84C', letterSpacing: 8 }}>{presenceCodes[codeTargetDate]}</div>



                      <div style={{ fontSize: 10, color: '#556', marginTop: 6 }}>Valable uniquement le {codeTargetDate}</div>



                    </div>



                  )}



                  {Object.keys(presenceCodes).length > 0 && (



                    <div style={{ marginTop: 16 }}>



                      <div style={{ fontSize: 10, color: '#556', marginBottom: 8, textTransform: 'uppercase', letterSpacing: 1 }}>Historique des codes</div>



                      {Object.entries(presenceCodes).sort((a, b) => b[0].localeCompare(a[0])).map(([date, code]) => (



                        <div key={date} style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', borderBottom: '1px solid rgba(255,255,255,.05)', fontSize: 12 }}>



                          <span style={{ color: '#889' }}>{date}</span>



                          <span style={{ color: '#C9A84C', fontWeight: 700, letterSpacing: 3 }}>{code}</span>



                          {date === todayStr && <span className="badge green">Actif</span>}



                        </div>



                      ))}



                    </div>



                  )}



                </div>







                <div className="card">



                  <div className="card-title">?? Simulation � Validation employ�



                    <span className="card-badge">D�mo</span>



                  </div>



                  <div style={{ fontSize: 11, color: '#667', marginBottom: 14, lineHeight: 1.5 }}>



                    Dans le vrai syst�me, l'employ� valide le code depuis son propre dashboard. Cette section simule ce sc�nario pour la d�monstration.



                  </div>



                  <div style={{ marginBottom: 10 }}>



                    <label style={{ fontSize: 10, color: '#667', textTransform: 'uppercase', letterSpacing: '.8px', display: 'block', marginBottom: 5 }}>Employ�</label>



                    <select value={demoValidNom} onChange={e => setDemoValidNom(e.target.value)}



                      style={{ width: '100%', background: '#0d1b2a', border: '1px solid rgba(255,255,255,.15)', borderRadius: 8, padding: '9px 12px', color: '#fff', fontFamily: 'inherit', fontSize: 13, outline: 'none' }}>



                      <option value="">-- choisir --</option>



                      {personnel.map(p => <option key={p.nom} value={p.nom} style={{ background: '#0d1b2a' }}>{p.nom}</option>)}



                    </select>



                  </div>



                  <div style={{ marginBottom: 14 }}>



                    <label style={{ fontSize: 10, color: '#667', textTransform: 'uppercase', letterSpacing: '.8px', display: 'block', marginBottom: 5 }}>Code du jour</label>



                    <input value={demoValidCode} onChange={e => setDemoValidCode(e.target.value)} placeholder="Ex : AB12CD"



                      style={{ width: '100%', background: 'rgba(255,255,255,.05)', border: '1px solid rgba(255,255,255,.07)', borderRadius: 8, padding: '9px 12px', color: '#fff', fontFamily: 'inherit', fontSize: 13, outline: 'none', textTransform: 'uppercase', letterSpacing: 3 }} />



                  </div>



                  <button className="btn-gold" style={{ width: '100%' }} onClick={validerCodeEmploye}>? Valider la pr�sence</button>



                  {demoValidMsg && (



                    <div style={{ marginTop: 12, padding: '10px 14px', borderRadius: 8, background: demoValidMsg.ok ? 'rgba(76,175,80,.12)' : 'rgba(239,83,80,.12)', border: `1px solid ${demoValidMsg.ok ? '#4caf5044' : '#ef535044'}`, fontSize: 12, color: demoValidMsg.ok ? '#66bb6a' : '#ef8080' }}>



                      {demoValidMsg.ok ? '? ' : '? '}{demoValidMsg.msg}



                    </div>



                  )}



                  {presenceCodes[todayStr] && (



                    <div style={{ marginTop: 14, padding: '8px 12px', borderRadius: 8, background: 'rgba(255,255,255,.03)', fontSize: 11, color: '#556', textAlign: 'center' }}>



                      Code actif aujourd'hui : <strong style={{ color: '#C9A84C', letterSpacing: 3 }}>{presenceCodes[todayStr]}</strong>



                    </div>



                  )}



                </div>



              </div>







              <div className="card" style={{ marginTop: 16 }}>



                <div className="card-title">



                  ?? Pr�sence du jour



                  <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>



                    <input type="date" value={presenceDate} onChange={e => setPresenceDate(e.target.value)}



                      style={{ background: '#0d1b2a', border: '1px solid rgba(255,255,255,.15)', borderRadius: 8, padding: '5px 10px', color: '#fff', fontFamily: 'inherit', fontSize: 12, outline: 'none' }} />



                    <span className="card-badge">



                      {personnelDuJour.filter(p => p.present).length}/{personnelDuJour.length} présents



                    </span>



                  </div>



                </div>



                <table className="tbl">



                  <thead><tr><th>Collaborateur</th><th>Poste</th><th>D�partement</th><th>Heure d'arriv�e</th><th>Pr�sence</th></tr></thead>



                  <tbody>



                    {personnelDuJour.map(p => (



                      <tr key={p.nom}>



                        <td>



                          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>



                            <div style={{ width: 26, height: 26, borderRadius: '50%', background: p.color + '22', color: p.color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 9, fontWeight: 700 }}>{p.av}</div>



                            <span className="bold">{p.nom}</span>



                          </div>



                        </td>



                        <td>{p.poste}</td>



                        <td>{p.departement || p.filiale || '�'}</td>



                        <td style={{ color: p.present ? '#66bb6a' : '#ef5350', fontWeight: p.present ? 600 : 400 }}>{p.arr}</td>



                        <td>{p.present ? <span className="badge green">? Pr�sent</span> : <span className="badge red">? Absent</span>}</td>



                      </tr>



                    ))}



                  </tbody>



                </table>



                <div style={{ marginTop: 14, display: 'flex', gap: 16, fontSize: 11 }}>



                  <span style={{ color: '#66bb6a' }}>? Présents : {personnelDuJour.filter(p => p.present).length}</span>



                  <span style={{ color: '#ef5350' }}>? Absents : {personnelDuJour.filter(p => !p.present).length}</span>



                  <span style={{ color: '#aaa' }}>Taux : {Math.round(personnelDuJour.filter(p => p.present).length / personnelDuJour.length * 100)}%</span>



                </div>



              </div>



            </div>







            {/* --- D�CISIONS --- */}



            <div className={`page ${activePage === 'decisions' ? 'active' : ''}`}>



              <div className="page-header">



                <div>



                  <div className="page-title">⚖? D�cisions � prendre</div>



                  <div className="page-sub">{decisions.length} d�cisions � {decisions.filter(d => d.prio === 'URGENT').length} urgentes</div>



                </div>



                <button className="btn-gold" onClick={() => openModal('decision', { prio: 'NORMALE', statut: 'attente' })}>+ Nouvelle d�cision</button>



              </div>



              <div className="kpi-grid">



                {[



                  { label: 'Total', val: decisions.length, color: '#42a5f5', icon: '??' },



                  { label: 'Urgentes', val: decisions.filter(d => d.prio === 'URGENT').length, color: '#ef5350', icon: '??' },



                  { label: 'En cours', val: decisions.filter(d => d.statut === 'en_cours').length, color: '#C9A84C', icon: '⚡' },



                  { label: 'En attente', val: decisions.filter(d => d.statut === 'attente').length, color: '#ff9800', icon: '?' },



                ].map(k => (



                  <div key={k.label} className="kpi-card">



                    <div className="kpi-accent" style={{ background: k.color }} />



                    <div className="kpi-icon">{k.icon}</div>



                    <div className="kpi-val" style={{ color: k.color }}>{k.val}</div>



                    <div className="kpi-label">{k.label}</div>



                  </div>



                ))}



              </div>



              <SecTitle>Liste des d�cisions</SecTitle>



              <div className="card">



                <table className="tbl">



                  <thead><tr><th>D�cision</th><th>Priorit�</th><th>Statut</th><th>Actions</th></tr></thead>



                  <tbody>



                    {decisions.map((d, i) => (



                      <tr key={i}>



                        <td className="bold" style={{ fontSize: 12 }}>{d.text}</td>



                        <td><Badge statut={d.prio} /></td>



                        <td><Badge statut={d.statut} /></td>



                        <td style={{ display: 'flex', gap: 4 }}>



                          <button className="btn-outline" style={{ padding: '4px 8px', fontSize: 11 }} onClick={() => openModal('decision', { ...d, _isEdit: true, _idx: i })}>??</button>



                          <button className="btn-outline" style={{ padding: '4px 8px', fontSize: 11, color: '#ef5350' }} onClick={() => setDecisions(prev => prev.filter((_, j) => j !== i))}>???</button>



                        </td>



                      </tr>



                    ))}



                  </tbody>



                </table>



              </div>



            </div>
            {/* --- PROCES-VERBAUX --- */}

            <div className={`page ${activePage === 'proces-verbaux' ? 'active' : ''}`}>
              <ProcesVerbauxRH />
            </div>








            {/* --- AGENDA --- */}



            <div className={`page ${activePage === 'agenda' ? 'active' : ''}`}>



              <div className="page-header">



                <div>



                  <div className="page-title">?? Agenda � R�unions & Rendez-vous</div>



                  <div className="page-sub">CODIR � R�unions �quipe � RDV externes � PV � D�cisions</div>



                </div>



              </div>



              <AgendaSection />



            </div>







            {/* --- T�CHES DG --- */}



            <div className={`page ${activePage === 'taches' ? 'active' : ''}`}>



              {(() => {



                const tasksDuJour = dgTasks.filter(t => t.date === taskCalDate);



                const pending = tasksDuJour.filter(t => !t.done).length;







                const MOIS_NOMS = ['Janvier', 'F�vrier', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Ao�t', 'Septembre', 'Octobre', 'Novembre', 'D�cembre'];



                const { y, m } = taskCalNav;



                const firstDay = new Date(y, m, 1).getDay();



                const daysInMonth = new Date(y, m + 1, 0).getDate();



                const todayD = new Date();



                const isCurMonth = y === todayD.getFullYear() && m === todayD.getMonth();







                const daysWithTasks = new Set(dgTasks.filter(t => {



                  const td = new Date(t.date);



                  return td.getFullYear() === y && td.getMonth() === m;



                }).map(t => new Date(t.date).getDate()));







                const prevMonth = () => setTaskCalNav(prev => prev.m === 0 ? { y: prev.y - 1, m: 11 } : { ...prev, m: prev.m - 1 });



                const nextMonth = () => setTaskCalNav(prev => prev.m === 11 ? { y: prev.y + 1, m: 0 } : { ...prev, m: prev.m + 1 });







                const prioBadge = p => {



                  const map = { urgente: ['#ef5350', '#ef535022'], haute: ['#ffb74d', '#ffb74d22'], normale: ['#64b5f6', '#64b5f622'] };



                  const [c, bg] = map[p] || ['#aaa', '#aaa22'];



                  return <span style={{ fontSize: 9, fontWeight: 700, color: c, background: bg, padding: '2px 7px', borderRadius: 99, textTransform: 'uppercase' }}>{p}</span>;



                };







                return (



                  <>



                    <div className="page-header">



                      <div>



                        <div className="page-title">? T�ches DG</div>



                        <div className="page-sub">



                          {taskCalDate === todayStr ? "Aujourd'hui" : taskCalDate} � {tasksDuJour.length} t�che{tasksDuJour.length !== 1 ? 's' : ''} � {pending} en attente



                        </div>



                      </div>



                      <button className="btn-gold" onClick={() => openModal('task', { date: taskCalDate, priorite: 'normale', categorie: 'Admin' })}>+ Ajouter une t�che</button>



                    </div>







                    <div className="grid2">



                      <div className="card">



                        <div className="card-title">



                          ?? T�ches du {taskCalDate === todayStr ? "jour" : taskCalDate}



                          <span className="card-badge">{pending} en attente</span>



                        </div>







                        {tasksDuJour.length === 0 ? (



                          <div style={{ textAlign: 'center', padding: '30px 0', color: '#445', fontSize: 12 }}>



                            <div style={{ fontSize: 28, marginBottom: 8 }}>??</div>



                            Aucune t�che pour ce jour.



                            <div style={{ marginTop: 12 }}>



                              <button className="btn-outline" style={{ fontSize: 11 }} onClick={() => openModal('task', { date: taskCalDate, priorite: 'normale', categorie: 'Admin' })}>+ Ajouter</button>



                            </div>



                          </div>



                        ) : (



                          tasksDuJour.map((t) => (



                            <div key={t.id} className="task-row">



                              <div className={`task-check ${t.done ? 'done' : ''}`} onClick={() => toggleTask(t)}>



                                {t.done ? '?' : ''}



                              </div>



                              <div style={{ flex: 1 }}>



                                <div className={`task-text ${t.done ? 'done' : ''}`}>{t.text}</div>



                                <div style={{ display: 'flex', gap: 6, marginTop: 3, alignItems: 'center' }}>



                                  {prioBadge(t.priorite)}



                                  <span style={{ fontSize: 9, color: '#556' }}>{t.categorie}</span>



                                </div>



                              </div>



                              <div style={{ display: 'flex', gap: 4 }}>



                                <button style={{ background: 'none', border: 'none', color: '#667', cursor: 'pointer', fontSize: 13 }}



                                  onClick={() => openModal('task', { _id: t.id, text: t.text, date: t.date, priorite: t.priorite, categorie: t.categorie })}>??</button>



                                <button style={{ background: 'none', border: 'none', color: '#ef5350', cursor: 'pointer', fontSize: 13 }}



                                  onClick={() => deleteTask(t.id)}>???</button>



                              </div>



                            </div>



                          ))



                        )}







                        {tasksDuJour.length > 0 && (



                          <div style={{ marginTop: 14, paddingTop: 12, borderTop: '1px solid rgba(255,255,255,.06)', display: 'flex', gap: 12, fontSize: 11 }}>



                            <span style={{ color: '#66bb6a' }}>? {tasksDuJour.filter(t => t.done).length} faites</span>



                            <span style={{ color: '#ffb74d' }}>? {pending} restantes</span>



                            <span style={{ color: '#aaa' }}>{tasksDuJour.length > 0 ? Math.round(tasksDuJour.filter(t => t.done).length / tasksDuJour.length * 100) : 0}% accompli</span>



                          </div>



                        )}



                      </div>







                      <div className="card">



                        <div className="card-title">



                          <button onClick={prevMonth} style={{ background: 'none', border: 'none', color: '#889', cursor: 'pointer', fontSize: 16, padding: '0 6px' }}>�</button>



                          <span style={{ flex: 1, textAlign: 'center', fontSize: 13 }}>{MOIS_NOMS[m]} {y}</span>



                          <button onClick={nextMonth} style={{ background: 'none', border: 'none', color: '#889', cursor: 'pointer', fontSize: 16, padding: '0 6px' }}>�</button>



                        </div>







                        <div className="cal-grid" style={{ gap: 4 }}>



                          {['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'].map(j => (



                            <div key={j} style={{ fontSize: 9, color: '#445', textAlign: 'center', padding: '4px 0', fontWeight: 700, letterSpacing: .5 }}>{j}</div>



                          ))}



                          {Array.from({ length: (firstDay === 0 ? 6 : firstDay - 1) }, (_, i) => (



                            <div key={`e${i}`} />



                          ))}



                          {Array.from({ length: daysInMonth }, (_, i) => {



                            const d = i + 1;



                            const dateStr = `${y}-${String(m + 1).padStart(2, '0')}-${String(d).padStart(2, '0')}`;



                            const isToday = isCurMonth && d === todayD.getDate();



                            const isSelected = dateStr === taskCalDate;



                            const hasTasks = daysWithTasks.has(d);



                            return (



                              <div key={d}



                                onClick={() => setTaskCalDate(dateStr)}



                                style={{



                                  fontSize: 11, textAlign: 'center', padding: '7px 2px', borderRadius: 8,



                                  cursor: 'pointer', position: 'relative', fontWeight: isSelected || isToday ? 700 : 400,



                                  background: isSelected ? '#C9A84C' : isToday ? 'rgba(201,168,76,.15)' : 'transparent',



                                  color: isSelected ? '#111' : isToday ? '#C9A84C' : '#aaa',



                                  border: isSelected ? 'none' : isToday ? '1px solid rgba(201,168,76,.4)' : '1px solid transparent',



                                  transition: 'all .15s',



                                }}>



                                {d}



                                {hasTasks && !isSelected && (



                                  <div style={{ position: 'absolute', bottom: 2, left: '50%', transform: 'translateX(-50%)', width: 4, height: 4, borderRadius: '50%', background: isToday ? '#C9A84C' : '#42a5f5' }} />



                                )}



                              </div>



                            );



                          })}



                        </div>







                        <div style={{ marginTop: 14, display: 'flex', gap: 16, fontSize: 10, color: '#556', flexWrap: 'wrap' }}>



                          <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}><span style={{ width: 8, height: 8, borderRadius: '50%', background: '#42a5f5', display: 'inline-block' }} /> A des t�ches</span>



                          <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}><span style={{ width: 8, height: 8, borderRadius: 2, background: '#C9A84C', display: 'inline-block' }} /> S�lectionn�</span>



                          <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}><span style={{ width: 8, height: 8, borderRadius: 2, background: 'rgba(201,168,76,.15)', border: '1px solid rgba(201,168,76,.4)', display: 'inline-block' }} /> Aujourd'hui</span>



                        </div>







                        <div style={{ marginTop: 16, borderTop: '1px solid rgba(255,255,255,.06)', paddingTop: 14 }}>



                          <div style={{ fontSize: 10, color: '#556', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 8 }}>Prochaines t�ches</div>



                          {tasks.filter(t => t.date >= todayStr && !t.done && (!t.employee_id || t.employee_id === user?.id)).slice(0, 4).map(t => (



                            <div key={t.id} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '5px 0', borderBottom: '1px solid rgba(255,255,255,.04)', cursor: 'pointer' }}



                              onClick={() => setTaskCalDate(t.date)}>



                              <div style={{ fontSize: 9, color: '#C9A84C', fontWeight: 700, minWidth: 32 }}>{t.date.slice(8)}/{t.date.slice(5, 7)}</div>



                              <div style={{ fontSize: 11, color: '#ccc', flex: 1 }}>{t.text}</div>



                              {prioBadge(t.priorite)}



                            </div>



                          ))}



                          {tasks.filter(t => t.date >= todayStr && !t.done).length === 0 && (



                            <div style={{ fontSize: 11, color: '#445', fontStyle: 'italic' }}>Aucune t�che � venir.</div>



                          )}



                        </div>



                      </div>



                    </div>



                  </>



                );



              })()}



            </div>







            {/* --- RAPPORTS --- */}



            <div className={`page ${activePage === 'rapports' ? 'active' : ''}`}>



              <div style={{ padding: '40px', textAlign: 'center', color: '#666' }}>



                <h3>?? Section Rapports DG</h3>



                <p>Cette section sera disponible prochainement.</p>



              </div>



            </div>







            {/* --- ALERTES --- */}



            <div className={`page ${activePage === 'alertes' ? 'active' : ''}`}>



              <div className="page-header">



                <div><div className="page-title">⚠? Alertes & Notifications</div><div className="page-sub">Centre de contr�le DG</div></div>



                <button className="btn-outline">Tout marquer lu</button>



              </div>



              <div className="grid2">



                <div>



                  <SecTitle>Alertes urgentes</SecTitle>



                  <div className="card">



                    {projets.filter(p => p.statut === 'retard').length > 0



                      ? projets.filter(p => p.statut === 'retard').map((p, i) => <AlertItem key={i} dot="#ef5350" txt={`${p.nom} � avancement ${p.av}% (retard)`} time={`RETARD � ${p.filiale}`} />)



                      : <div style={{ fontSize: 12, color: '#445', fontStyle: 'italic' }}>Aucune alerte urgente.</div>



                    }



                  </div>



                  <SecTitle style={{ marginTop: 20 }}>Informations</SecTitle>



                  <div className="card" style={{ marginTop: 14 }}>



                    {projets.filter(p => p.statut === 'en_cours').map((p, i) => <AlertItem key={i} dot="#42a5f5" txt={`${p.nom} � ${p.av}% avanc�`} time={`INFO � ${p.filiale}`} />)}



                  </div>



                </div>



                <div>



                  <SecTitle>Historique (7 derniers jours)</SecTitle>



                  <div className="card">



                    {personnel.filter(p => p.present).slice(0, 4).map((p, i) => <AlertItem key={i} dot={p.color} txt={`${p.nom} � arriv�e ${p.arr}`} time={`Aujourd'hui ${p.arr}`} />)}



                  </div>



                </div>



              </div>



            </div>







            {/* --- D�PARTEMENTS --- */}



            <div className={`page ${activePage === 'departements' ? 'active' : ''}`}>



              <div className="page-header">



                <div><div className="page-title">??? D�partements</div><div className="page-sub">{depts.length} d�partements � FHC Groupe SARL</div></div>



                <button className="btn-gold" onClick={() => openModal('dept')}>+ Nouveau d�partement</button>



              </div>



              <div className="kpi-grid">



                {[



                  { label: 'D�partements', value: depts.length, icon: '???', color: '#C9A84C' },



                  { label: 'Effectif total', value: depts.reduce((s, d) => s + (Number(d.effectif) || 0), 0), icon: '??', color: '#42a5f5' },



                  { label: 'Budget total', value: '12.3 M', icon: '??', color: '#66bb6a' },



                  { label: 'Actifs', value: depts.length, icon: '?', color: '#4caf50' },



                ].map(k => (



                  <div key={k.label} className="kpi-card">



                    <div className="kpi-accent" style={{ background: k.color }} />



                    <div className="kpi-icon">{k.icon}</div>



                    <div className="kpi-val" style={{ color: k.color }}>{k.value}</div>



                    <div className="kpi-label">{k.label}</div>



                  </div>



                ))}



              </div>



              <SecTitle>Liste des d�partements</SecTitle>



              <div className="card">



                <table className="tbl">



                  <thead><tr><th>D�partement</th><th>Responsable</th><th>Filiale</th><th>Effectif</th><th>Budget</th><th>Statut</th><th>Actions</th></tr></thead>



                  <tbody>



                    {depts.map(d => (



                      <tr key={d.id} style={{ cursor: 'pointer' }} onClick={() => setSelectedDept(d)}>



                        <td className="bold">{d.nom}</td>



                        <td>{d.chef}</td>



                        <td>{d.filiale}</td>



                        <td>{d.effectif}</td>



                        <td style={{ color: '#C9A84C' }}>{d.budget}</td>



                        <td><span className="badge green">Actif</span></td>



                        <td style={{ display: 'flex', gap: 4 }} onClick={e => e.stopPropagation()}>



                          <button className="btn-outline" style={{ padding: '4px 10px', fontSize: 11 }} onClick={() => openModal('dept', { ...d, _isEdit: true })}>??</button>



                          <button className="btn-outline" style={{ padding: '4px 10px', fontSize: 11, color: '#ef5350' }} onClick={() => deleteDept(d.id)}>???</button>



                        </td>



                      </tr>



                    ))}



                  </tbody>



                </table>



              </div>



            </div>







            {/* Vue Departements */}



{/* === VUE DEPARTEMENTS === */}



            <div className={`page ${activePage === 'vue-departements' ? 'active' : ''}`}>
              <DeptOverviewSection />
            </div>



            {/* --- PERFORMANCE & SCORES --- */}



            <div className={`page ${activePage === 'performance-scores' ? 'active' : ''}`}>



              <div className="page-header">



                <div>



                  <div className="page-title">? Notation Performance</div>



                  <div className="page-sub">�valuation du travail en �quipe et du respect des r�gles � Section r�serv�e au PDG</div>



                </div>



                <div className="page-actions">



                  <button 



                    className="btn-outline"



                    onClick={async () => {



                      try {



                        // Recharger les donn�es avec les scores � jour



                        const res = await api.dashboard.getDG();



                        if (res?.employees?.length) {



                          const employeesWithTasks = res.employees.map(e => {



                            const mapped = mapEmployee(e);



                            const empTasks = (tasks || []).filter(t => t.employee_id === mapped.user_id);



                            return {



                              ...mapped,



                              assignedTasks: empTasks,



                              taches: empTasks.length,



                              done: empTasks.filter(t => t.done).length,



                            };



                          });



                          setPersonnel(employeesWithTasks);



                          setEmployes(employeesWithTasks);



                        }



                        alert('? Scores actualis�s !');



                      } catch (error) {



                        console.error('Erreur lors du rechargement:', error);



                        alert('? Erreur lors de l\'actualisation');



                      }



                    }}



                  >



                    ?? Actualiser les scores



                  </button>



                </div>



              </div>







              {/* KPI Cards */}



              <div className="kpi-grid">



                <div className="kpi-card">



                  <div className="kpi-accent" style={{ background: '#4caf50' }} />



                  <div className="kpi-icon">?</div>



                  <div className="kpi-val" style={{ color: '#4caf50' }}>



                    {personnel.filter(p => p.score_travail_equipe >= 70 && p.score_respect_regles >= 70).length}



                  </div>



                  <div className="kpi-label">Bonne performance</div>



                  <div className="kpi-trend up">Score = 70/100</div>



                </div>



                <div className="kpi-card">



                  <div className="kpi-accent" style={{ background: '#ff9800' }} />



                  <div className="kpi-icon">??</div>



                  <div className="kpi-val" style={{ color: '#ff9800' }}>



                    {personnel.filter(p => (p.score_travail_equipe > 0 && p.score_travail_equipe < 70) || (p.score_respect_regles > 0 && p.score_respect_regles < 70)).length}



                  </div>



                  <div className="kpi-label">� am�liorer</div>



                  <div className="kpi-trend neutral">Score 40-69</div>



                </div>



                <div className="kpi-card">



                  <div className="kpi-accent" style={{ background: '#778899' }} />



                  <div className="kpi-icon">??</div>



                  <div className="kpi-val" style={{ color: '#778899' }}>



                    {personnel.filter(p => !p.score_travail_equipe && !p.score_respect_regles).length}



                  </div>



                  <div className="kpi-label">Non �valu�s</div>



                  <div className="kpi-trend neutral">En attente de notation</div>



                </div>



                <div className="kpi-card">



                  <div className="kpi-accent" style={{ background: '#C9A84C' }} />



                  <div className="kpi-icon">??</div>



                  <div className="kpi-val" style={{ color: '#C9A84C' }}>



                    {Math.round(personnel.reduce((acc, p) => acc + (p.score_travail_equipe || 0) + (p.score_respect_regles || 0), 0) / (personnel.length * 2) || 0)}



                  </div>



                  <div className="kpi-label">Moyenne g�n�rale</div>



                  <div className="kpi-trend up">/100</div>



                </div>



              </div>







              <div className="card">



                <div className="card-title">



                  ?? Tableau de notation



                  <span style={{ fontSize: 11, color: '#778', fontWeight: 400, marginLeft: 12 }}>



                    {personnel.length} employ�{personnel.length > 1 ? 's' : ''}



                  </span>



                </div>



                <table className="tbl">



                  <thead>



                    <tr>



                      <th>Employ�</th>



                      <th>Poste</th>



                      <th>D�partement</th>



                      <th>Score Global</th>



                      <th style={{ textAlign: 'center' }}>Travail en �quipe<br /><span style={{ fontSize: 10, color: '#778', fontWeight: 400 }}>(10% du total)</span></th>



                      <th style={{ textAlign: 'center' }}>Respect des r�gles<br /><span style={{ fontSize: 10, color: '#778', fontWeight: 400 }}>(5% du total)</span></th>



                      <th>Actions</th>



                    </tr>



                  </thead>



                  <tbody>



                    {personnel.length === 0 ? (



                      <tr>



                        <td colSpan="7" style={{ textAlign: 'center', padding: 40, color: '#667' }}>



                          Aucun employ� � �valuer



                        </td>



                      </tr>



                    ) : (



                      personnel.map(p => {



                        // Utiliser le score_performance de la BDD (score calcul� et stock�)



                        const scoreGlobal = p.score_performance || p.score || 0;



                        const scoreTravailEquipe = p.score_travail_equipe || 0;



                        const scoreRespectRegles = p.score_respect_regles || 0;



                        const scorePresence = Number(p.score_presence) || 0;



                        const scoreDelaiTaches = Number(p.score_delai_taches) || 0;



                        const scoreObjectifs = Number(p.score_objectifs) || 0;



                        const isNonEvalue = !scoreTravailEquipe && !scoreRespectRegles;



                        



                        const getColorForScore = (score) => {



                          if (score >= 80) return '#4caf50';



                          if (score >= 60) return '#C9A84C';



                          if (score >= 40) return '#ff9800';



                          return '#ef5350';



                        };



                        



                        const getBadgeForScore = (score) => {



                          if (score >= 80) return { label: 'Excellent', color: '#4caf50' };



                          if (score >= 60) return { label: 'Bien', color: '#C9A84C' };



                          if (score >= 40) return { label: 'Moyen', color: '#ff9800' };



                          return { label: 'Faible', color: '#ef5350' };



                        };



                        



                        return (



                          <tr key={p.id} style={{ opacity: isNonEvalue ? 0.6 : 1 }}>



                            <td>



                              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>



                                <div style={{ width: 32, height: 32, borderRadius: '50%', background: p.color + '22', color: p.color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 700 }}>{p.av}</div>



                                <div>



                                  <div className="bold">{p.nom}</div>



                                  {isNonEvalue && <div style={{ fontSize: 10, color: '#778', marginTop: 2 }}>?? Non �valu�</div>}



                                </div>



                              </div>



                            </td>



                            <td>{p.poste}</td>



                            <td>{p.departement || p.filiale || '�'}</td>



                            <td>



                              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>



                                <div 



                                  style={{ width: 46, height: 46, borderRadius: '50%', background: `conic-gradient(${getColorForScore(scoreGlobal)} ${scoreGlobal}%, #1a2332 0)`, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'help' }}



                                  title={`D�tails du score:\n� Pr�sence: ${scorePresence.toFixed(1)} (15%)\n� D�lai t�ches: ${scoreDelaiTaches.toFixed(1)} (30%)\n� Objectifs: ${scoreObjectifs.toFixed(1)} (40%)\n� Travail �quipe: ${scoreTravailEquipe} (10%)\n� Respect r�gles: ${scoreRespectRegles} (5%)`}



                                >



                                  <div style={{ width: 38, height: 38, borderRadius: '50%', background: '#0d1b2a', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 700, color: getColorForScore(scoreGlobal) }}>



                                    {Math.round(scoreGlobal)}



                                  </div>



                                </div>



                                <div>



                                  <div style={{ fontSize: 11, fontWeight: 600 }}>{Math.round(scoreGlobal)}/100</div>



                                  <div style={{ fontSize: 9, color: getColorForScore(scoreGlobal) }}>{getBadgeForScore(scoreGlobal).label}</div>



                                  {(scorePresence > 0 || scoreDelaiTaches > 0 || scoreObjectifs > 0) && (



                                    <div style={{ fontSize: 8, color: '#556', marginTop: 2 }}>



                                      ?? Calcul�



                                    </div>



                                  )}



                                </div>



                              </div>



                            </td>



                            <td>



                              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6 }}>



                                <div style={{ width: '100%', maxWidth: 120, background: '#1a2332', borderRadius: 6, height: 10, overflow: 'hidden' }}>



                                  <div style={{ width: `${scoreTravailEquipe}%`, height: '100%', background: scoreTravailEquipe ? getColorForScore(scoreTravailEquipe) : '#334', transition: 'width 0.3s' }} />



                                </div>



                                <span style={{ fontSize: 13, fontWeight: 600, color: scoreTravailEquipe ? getColorForScore(scoreTravailEquipe) : '#667' }}>



                                  {scoreTravailEquipe || '�'}{scoreTravailEquipe ? '/100' : ''}



                                </span>



                              </div>



                            </td>



                            <td>



                              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6 }}>



                                <div style={{ width: '100%', maxWidth: 120, background: '#1a2332', borderRadius: 6, height: 10, overflow: 'hidden' }}>



                                  <div style={{ width: `${scoreRespectRegles}%`, height: '100%', background: scoreRespectRegles ? getColorForScore(scoreRespectRegles) : '#334', transition: 'width 0.3s' }} />



                                </div>



                                <span style={{ fontSize: 13, fontWeight: 600, color: scoreRespectRegles ? getColorForScore(scoreRespectRegles) : '#667' }}>



                                  {scoreRespectRegles || '�'}{scoreRespectRegles ? '/100' : ''}



                                </span>



                              </div>



                            </td>



                            <td>



                              <button 



                                className={isNonEvalue ? "btn-gold" : "btn-outline"}



                                style={{ padding: '8px 16px', fontSize: 11, fontWeight: 600 }} 



                                onClick={() => openModal('notation-performance', { ...p })}



                              >



                                {isNonEvalue ? '?? �valuer' : '?? Modifier'}



                              </button>



                            </td>



                          </tr>



                        );



                      })



                    )}



                  </tbody>



                </table>



              </div>







              {/* Guide de notation */}



              <div style={{ marginTop: 20, display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 16 }}>



                <div style={{ padding: 16, background: 'rgba(201,168,76,.08)', border: '1px solid rgba(201,168,76,.25)', borderRadius: 10 }}>



                  <div style={{ fontSize: 12, fontWeight: 600, color: '#C9A84C', marginBottom: 8 }}>?? Travail en �quipe (10%)</div>



                  <div style={{ fontSize: 11, color: '#889', lineHeight: 1.6 }}>



                    � Collaboration avec les coll�gues<br />



                    � Partage d'informations et entraide<br />



                    � Communication efficace<br />



                    � Esprit d'�quipe et solidarit�



                  </div>



                </div>



                <div style={{ padding: 16, background: 'rgba(66,165,245,.08)', border: '1px solid rgba(66,165,245,.25)', borderRadius: 10 }}>



                  <div style={{ fontSize: 12, fontWeight: 600, color: '#42a5f5', marginBottom: 8 }}>?? Respect des r�gles (5%)</div>



                  <div style={{ fontSize: 11, color: '#889', lineHeight: 1.6 }}>



                    � Respect des horaires et ponctualit�<br />



                    � Hygi�ne et tenue professionnelle<br />



                    � Application des proc�dures<br />



                    � Discipline et professionnalisme



                  </div>



                </div>



                <div style={{ padding: 16, background: 'rgba(102,187,106,.08)', border: '1px solid rgba(102,187,106,.25)', borderRadius: 10 }}>



                  <div style={{ fontSize: 12, fontWeight: 600, color: '#66bb6a', marginBottom: 8 }}>?? Rappel</div>



                  <div style={{ fontSize: 11, color: '#889', lineHeight: 1.6 }}>



                    Les autres composantes sont calcul�es automatiquement :<br />



                    � Pr�sence (15%)<br />



                    � D�lais t�ches (30%)<br />



                    � Objectifs (40%)



                  </div>



                </div>



              </div>



            </div>



{/* --- DEMANDES DE PERMISSION --- */}
            <div className={`page ${activePage === 'demandes-permission' ? 'active' : ''}`}>
              <div className="page-header">
                <div>
                  <div className="page-title">?? Demandes de Permission</div>
                  <div className="page-sub">G�rer les demandes de cong�s, absences et permissions des employ�s</div>
                </div>
                <div className="page-actions">
                  <button 
                    className="btn-outline"
                    onClick={loadDemandesPermission}
                  >
                    ?? Actualiser
                  </button>
                </div>
              </div>

              {/* Statistiques */}
              <div className="kpi-grid">
                <div className="kpi-card">
                  <div className="kpi-accent" style={{ background: '#ff9800' }} />
                  <div className="kpi-icon">?</div>
                  <div className="kpi-val" style={{ color: '#ff9800' }}>
                    {demandesPermission.filter(d => d.statut === 'en_attente').length}
                  </div>
                  <div className="kpi-label">En attente</div>
                  <div className="kpi-trend neutral">� traiter</div>
                </div>
                <div className="kpi-card">
                  <div className="kpi-accent" style={{ background: '#4caf50' }} />
                  <div className="kpi-icon">?</div>
                  <div className="kpi-val" style={{ color: '#4caf50' }}>
                    {demandesPermission.filter(d => d.statut === 'approuvee').length}
                  </div>
                  <div className="kpi-label">Approuv�es</div>
                  <div className="kpi-trend up">Valid�es</div>
                </div>
                <div className="kpi-card">
                  <div className="kpi-accent" style={{ background: '#ef5350' }} />
                  <div className="kpi-icon">?</div>
                  <div className="kpi-val" style={{ color: '#ef5350' }}>
                    {demandesPermission.filter(d => d.statut === 'refusee').length}
                  </div>
                  <div className="kpi-label">Refus�es</div>
                  <div className="kpi-trend down">D�clin�es</div>
                </div>
                <div className="kpi-card">
                  <div className="kpi-accent" style={{ background: '#C9A84C' }} />
                  <div className="kpi-icon">??</div>
                  <div className="kpi-val" style={{ color: '#C9A84C' }}>
                    {demandesPermission.length}
                  </div>
                  <div className="kpi-label">Total</div>
                  <div className="kpi-trend neutral">Toutes demandes</div>
                </div>
              </div>

              {/* Onglets */}
              <div style={{ display: 'flex', gap: 8, marginBottom: 16, borderBottom: '1px solid rgba(255,255,255,.1)' }}>
                {[
                  { key: 'en_attente', label: '? En attente', count: demandesPermission.filter(d => d.statut === 'en_attente').length },
                  { key: 'approuvee', label: '? Approuv�es', count: demandesPermission.filter(d => d.statut === 'approuvee').length },
                  { key: 'refusee', label: '? Refus�es', count: demandesPermission.filter(d => d.statut === 'refusee').length },
                  { key: 'all', label: '?? Toutes', count: demandesPermission.length }
                ].map(tab => (
                  <button
                    key={tab.key}
                    onClick={() => setActiveTab(tab.key)}
                    style={{
                      padding: '12px 20px',
                      background: activeTab === tab.key ? 'rgba(201,168,76,.15)' : 'transparent',
                      border: 'none',
                      borderBottom: activeTab === tab.key ? '2px solid #C9A84C' : '2px solid transparent',
                      color: activeTab === tab.key ? '#C9A84C' : '#889',
                      fontSize: 13,
                      fontWeight: 600,
                      cursor: 'pointer',
                      transition: 'all 0.3s'
                    }}
                  >
                    {tab.label}
                    {tab.count > 0 && (
                      <span style={{
                        marginLeft: 8,
                        padding: '2px 8px',
                        background: activeTab === tab.key ? '#C9A84C' : '#334',
                        borderRadius: 12,
                        fontSize: 11,
                        color: '#fff'
                      }}>
                        {tab.count}
                      </span>
                    )}
                  </button>
                ))}
              </div>

              {/* Tableau des demandes */}
              <div className="card">
                <table className="tbl">
                  <thead>
                    <tr>
                      <th>Employ�</th>
                      <th>Type</th>
                      <th>P�riode</th>
                      <th>Jours</th>
                      <th>Raison</th>
                      <th>Date demande</th>
                      <th>Statut</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(() => {
                      const filtered = activeTab === 'all' 
                        ? demandesPermission 
                        : demandesPermission.filter(d => d.statut === activeTab);

                      if (filtered.length === 0) {
                        return (
                          <tr>
                            <td colSpan="8" style={{ textAlign: 'center', padding: 40, color: '#667' }}>
                              Aucune demande {activeTab !== 'all' ? `� l'�tat "${activeTab}"` : ''}
                            </td>
                          </tr>
                        );
                      }

                      return filtered.map(demande => {
                        const employee = demande.employee?.user || demande.user;
                        const typeColors = {
                          conge: '#42a5f5',
                          absence: '#ffc107',
                          maladie: '#ef5350',
                          autre: '#778899'
                        };
                        const typeIcons = {
                          conge: '???',
                          absence: '??',
                          maladie: '??',
                          autre: '??'
                        };

                        return (
                          <tr key={demande.id}>
                            <td>
                              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <div style={{
                                  width: 32,
                                  height: 32,
                                  borderRadius: '50%',
                                  background: '#C9A84C22',
                                  color: '#C9A84C',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  fontSize: 11,
                                  fontWeight: 700
                                }}>
                                  {employee?.prenom?.[0]}{employee?.nom?.[0]}
                                </div>
                                <div>
                                  <div className="bold">{employee?.prenom} {employee?.nom}</div>
                                  <div style={{ fontSize: 10, color: '#667' }}>{employee?.poste}</div>
                                </div>
                              </div>
                            </td>
                            <td>
                              <span style={{
                                display: 'inline-block',
                                padding: '4px 10px',
                                borderRadius: 12,
                                fontSize: 11,
                                fontWeight: 600,
                                background: typeColors[demande.type] + '22',
                                color: typeColors[demande.type]
                              }}>
                                {typeIcons[demande.type]} {demande.type_label}
                              </span>
                            </td>
                            <td>
                              <div style={{ fontSize: 12 }}>
                                <div><strong>{new Date(demande.date_debut).toLocaleDateString('fr-FR')}</strong></div>
                                <div style={{ color: '#667', fontSize: 10 }}>? {new Date(demande.date_fin).toLocaleDateString('fr-FR')}</div>
                              </div>
                            </td>
                            <td style={{ textAlign: 'center' }}>
                              <strong>{demande.nombre_jours}</strong> jour{demande.nombre_jours > 1 ? 's' : ''}
                            </td>
                            <td>
                              <div style={{ maxWidth: 200, fontSize: 12, lineHeight: 1.4, color: '#ccc' }}>
                                {demande.raison.substring(0, 80)}
                                {demande.raison.length > 80 ? '...' : ''}
                              </div>
                            </td>
                            <td style={{ fontSize: 11, color: '#889' }}>
                              {new Date(demande.created_at).toLocaleDateString('fr-FR')}
                            </td>
                            <td>
                              {demande.statut === 'en_attente' && (
                                <span className="badge orange">? En attente</span>
                              )}
                              {demande.statut === 'approuvee' && (
                                <span className="badge green">? Approuv�e</span>
                              )}
                              {demande.statut === 'refusee' && (
                                <span className="badge red">? Refus�e</span>
                              )}
                            </td>
                            <td>
                              <div style={{ display: 'flex', gap: 4 }}>
                                {demande.statut === 'en_attente' && (
                                  <>
                                    <button
                                      className="btn-outline"
                                      style={{ 
                                        padding: '6px 12px', 
                                        fontSize: 11, 
                                        background: 'rgba(76,175,80,.15)',
                                        borderColor: '#4caf50',
                                        color: '#4caf50'
                                      }}
                                      onClick={() => {
                                        setModalDemande(demande);
                                        setActionType('approuver');
                                        setCommentaireDG('');
                                      }}
                                    >
                                      ? Approuver
                                    </button>
                                    <button
                                      className="btn-outline"
                                      style={{ 
                                        padding: '6px 12px', 
                                        fontSize: 11,
                                        background: 'rgba(239,83,80,.15)',
                                        borderColor: '#ef5350',
                                        color: '#ef5350'
                                      }}
                                      onClick={() => {
                                        setModalDemande(demande);
                                        setActionType('refuser');
                                        setCommentaireDG('');
                                      }}
                                    >
                                      ? Refuser
                                    </button>
                                  </>
                                )}
                                {demande.statut !== 'en_attente' && (
                                  <button
                                    className="btn-outline"
                                    style={{ padding: '6px 12px', fontSize: 11 }}
                                    onClick={() => {
                                      setModalDemande(demande);
                                      setActionType('details');
                                    }}
                                  >
                                    ??? D�tails
                                  </button>
                                )}
                              </div>
                            </td>
                          </tr>
                        );
                      });
                    })()}
                  </tbody>
                </table>
              </div>
            </div>



{/* --- GESTION DES T�CHES --- */}



            <div className={`page ${activePage === 'gestion-taches' ? 'active' : ''}`}>



              <div className="page-header">



                <div>



                  <div className="page-title">?? Gestion des T�ches</div>



                  <div className="page-sub">Affectation et suivi de progression � {totalTasks} t�che{totalTasks !== 1 ? 's' : ''} assign�e{totalTasks !== 1 ? 's' : ''}</div>



                </div>



              </div>



              {/* -- Documents de preuve -- */}
              {(() => {
                const tachesAvecPreuve = tasks.filter(t => t.done && t.document_preuve);
                if (!tachesAvecPreuve.length) return null;
                return (
                  <div className="card" style={{ marginBottom: 20 }}>
                    <div className="card-title">?? Documents de preuve soumis <span className="card-badge">{tachesAvecPreuve.length}</span></div>
                    <table className="tbl">
                      <thead>
                        <tr>
                          <th>T�che</th>
                          <th>Employ�</th>
                          <th>Valid�e le</th>
                          <th>Document</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {tachesAvecPreuve.map(t => {
                          const emp = employes.find(e => e.user_id === t.employee_id);
                          const fileName = t.document_preuve.split('/').pop();
                          const ext = fileName.split('.').pop().toLowerCase();
                          const isImage = ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext);
                          const isPdf = ext === 'pdf';
                          // Construire l'URL directe du document sur le serveur
                          const directUrl = `https://fhcgroupesarl.com/plateforme/${t.document_preuve}`;
                          return (
                            <tr key={t.id}>
                              <td className="bold">{t.text}</td>
                              <td>{emp ? emp.nom : (t.employee?.nom || t.employee?.prenom || '�')}</td>
                              <td style={{ fontSize: 11, color: '#889' }}>
                                {t.completed_at ? new Date(t.completed_at).toLocaleDateString('fr-FR') : '�'}
                              </td>
                              <td>
                                <span style={{ fontSize: 11, color: '#C9A84C' }}>
                                  {isImage ? '???' : isPdf ? '??' : '??'} {fileName}
                                </span>
                              </td>
                              <td>
                                <button
                                  className="btn-outline"
                                  style={{ padding: '4px 10px', fontSize: 11 }}
                                  onClick={() => window.open(directUrl, '_blank')}
                                >
                                  ??? Voir
                                </button>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                );
              })()}

              <TaskManagementModule



                employes={employes}



                setEmployes={setEmployes}



                setTasks={setTasks}



                onTaskCreated={() => {



                  // Recharger aussi les donn�es du dashboard



                  api.dashboard.dg().then(data => {



                    if (data.recent_tasks) setTasks(data.recent_tasks.map(mapTask));



                  }).catch(err => console.error('Refresh dashboard error:', err));



                }}



              />            </div>







            {/* --- PARAM�TRES --- */}



            <div className={`page ${activePage === 'parametres' ? 'active' : ''}`}>



              <div className="page-header">



                <div><div className="page-title">⚙? Param�tres</div><div className="page-sub">Configuration de la plateforme</div></div>



              </div>



              <div className="grid2">



                <div className="card">



                  <div className="card-title">?? Informations entreprise</div>



                  <div style={{ display: 'flex', flexDirection: 'column', gap: 14, marginTop: 4 }}>



                    {[['Raison sociale', 'FHC Groupe SARL'], ['Si�ge social', 'Godomey, Abomey-Calavi, B�nin'], ['RCCM', 'RB/ABC/22 B 5806']].map(([lbl, val]) => (



                      <div key={lbl}>



                        <label style={{ fontSize: 10, color: '#667', textTransform: 'uppercase', letterSpacing: '.8px', display: 'block', marginBottom: 5 }}>{lbl}</label>



                        <input defaultValue={val} style={{ width: '100%', background: 'rgba(255,255,255,.05)', border: '1px solid rgba(255,255,255,.07)', borderRadius: 8, padding: '9px 12px', color: '#fff', fontFamily: 'inherit', fontSize: 13, outline: 'none' }} />



                      </div>



                    ))}



                    <button className="btn-gold" style={{ alignSelf: 'flex-start' }}>Enregistrer</button>



                  </div>



                </div>



                <div className="card">



                  <div className="card-title">?? Pr�f�rences notifications</div>



                  <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>



                    {TOGGLES.map((t, i) => (



                      <div key={t} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid rgba(255,255,255,.07)' }}>



                        <span style={{ fontSize: 12, color: '#aaa' }}>{t}</span>



                        <div onClick={() => setToggles(prev => prev.map((v, j) => j === i ? !v : v))}



                          style={{ width: 36, height: 20, borderRadius: 10, background: toggles[i] ? '#C9A84C' : 'rgba(255,255,255,.1)', cursor: 'pointer', transition: 'background .2s', position: 'relative' }}>



                          <div style={{ position: 'absolute', top: 2, left: toggles[i] ? 18 : 2, width: 16, height: 16, borderRadius: '50%', background: '#fff', transition: 'left .2s' }} />



                        </div>



                      </div>



                    ))}



                  </div>



                </div>



              </div>



            </div>







          </div>{/* /main */}



        </div>{/* /layout */}







        {/* PANEL NOTIFICATIONS */}



        {notifOpen && (



          <div className="notif-panel open">



            <div className="notif-title">



              ?? Notifications



              <button className="notif-close" onClick={() => setNotifOpen(false)}>?</button>



            </div>



            {projets.filter(p => p.statut === 'retard').map((p, i) => (



              <div key={i} className="notif-item">



                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>



                  <div style={{ width: 6, height: 6, borderRadius: '50%', background: '#ef5350', flexShrink: 0 }} />



                  <div className="notif-head">⚠? Projet en retard : {p.nom}</div>



                </div>



                <div className="notif-body">{p.filiale} � Avancement : {p.av}%</div>



                <div className="notif-time">Statut : retard</div>



              </div>



            ))}



            {personnel.filter(p => !p.present).slice(0, 3).map((p, i) => (



              <div key={`abs-${i}`} className="notif-item">



                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>



                  <div style={{ width: 6, height: 6, borderRadius: '50%', background: '#ff9800', flexShrink: 0 }} />



                  <div className="notif-head">?? {p.nom} absent</div>



                </div>



                <div className="notif-body">{p.poste} � {p.filiale}</div>



                <div className="notif-time">Aujourd'hui</div>



              </div>



            ))}



          </div>



        )}







        {/* --- MODALS FORMULAIRES (FormModal) --- */}



        <FormModal



          title={form._id ? 'Modifier la t�che' : 'Nouvelle t�che'}



          isOpen={modal === 'task'}



          onClose={closeModal}



          onSave={saveTask}



          initialData={form}



          fields={[



            { label: 'Titre de la t�che', name: 'text', required: true },



            { label: 'Description', name: 'description' },



            { label: 'Date', name: 'date', type: 'date' },



            { label: 'Priorit�', name: 'priorite', opts: ['urgente', 'haute', 'normale'] },



          ]}



        />







        <FormModal



          title={form._isEdit ? 'Modifier la filiale' : 'Nouvelle filiale'}



          isOpen={modal === 'filiale'}



          onClose={closeModal}



          onSave={saveFiliale}



          initialData={form}



          fields={[



            { label: 'Nom', name: 'nom', required: true },



            { label: 'Description', name: 'desc' },



            { label: 'CA estim� (ex: 1 200 000)', name: 'ca' },



            { label: 'Objectif (ex: 2 000 000)', name: 'obj' },



          ]}



        />







        <FormModal



          title={form._isEdit ? 'Modifier le collaborateur' : 'Nouveau collaborateur'}



          isOpen={modal === 'personnel'}



          onClose={closeModal}



          onSave={savePersonnel}



          initialData={form}



          onFieldChange={(name, value) => {



            if (name === 'departement_id' && value) {



              const deptObj = depts.find(d => String(d.id) === String(value));



              setForm(prev => ({



                ...prev,



                departement_id: value,



                filiale_id: deptObj?.filiale_id ?? prev.filiale_id,



              }));



            }



          }}



          fields={[



            { label: 'Pr�nom', name: 'prenom', required: true },



            { label: 'Nom', name: 'nom', required: true },



            { label: 'Email', name: 'email', type: 'email', required: true },



            { label: 'Mot de passe', name: 'password', type: 'password' },



            { label: 'Poste', name: 'poste', required: true },



            { label: 'Contrat', name: 'contrat', opts: ['CDI', 'CDD', 'Stage', 'Freelance'] },



            {



              label: 'D�partement',



              name: 'departement_id',



              type: 'select',



              opts: [



                { value: '', label: '� Aucun d�partement �' },



                ...depts.map(d => ({ value: d.id, label: `${d.nom} (${d.filiale})` }))



              ]



            },



          ]}



        />







        {/* --- MODAL NOTATION PERFORMANCE --- */}



        {modal === 'notation-performance' && (



          <div className="modal-overlay" onClick={closeModal}>



            <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 600 }}>



              <div className="modal-header">



                <div>



                  <div className="modal-title">? �valuer la performance</div>



                  <div style={{ fontSize: 12, color: '#778', marginTop: 4 }}>



                    {form.nom} � {form.poste}



                  </div>



                </div>



                <button className="modal-close" onClick={closeModal}>?</button>



              </div>







              <div className="modal-body" style={{ padding: 24 }}>



                {/* Score Travail en �quipe */}



                <div style={{ marginBottom: 24 }}>



                  <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#C9A84C', marginBottom: 8 }}>



                    ?? Travail en �quipe



                  </label>



                  <div style={{ fontSize: 11, color: '#778', marginBottom: 12, lineHeight: 1.5 }}>



                    �valuez la collaboration, l'entraide, la communication et l'esprit d'�quipe



                  </div>



                  



                  <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}>



                    <input



                      type="range"



                      min="0"



                      max="100"



                      step="5"



                      value={form.score_travail_equipe || 0}



                      onChange={(e) => setForm(prev => ({ ...prev, score_travail_equipe: parseInt(e.target.value) }))}



                      style={{ 



                        flex: 1, 



                        height: 8, 



                        borderRadius: 4,



                        background: `linear-gradient(to right, #C9A84C 0%, #C9A84C ${form.score_travail_equipe || 0}%, #1a2332 ${form.score_travail_equipe || 0}%, #1a2332 100%)`,



                        outline: 'none',



                        cursor: 'pointer'



                      }}



                    />



                    <input



                      type="number"



                      min="0"



                      max="100"



                      value={form.score_travail_equipe || 0}



                      onChange={(e) => setForm(prev => ({ ...prev, score_travail_equipe: Math.min(100, Math.max(0, parseInt(e.target.value) || 0)) }))}



                      style={{



                        width: 70,



                        padding: '8px 12px',



                        background: '#0d1b2a',



                        border: '1px solid rgba(255,255,255,.15)',



                        borderRadius: 8,



                        color: '#C9A84C',



                        fontSize: 14,



                        fontWeight: 700,



                        textAlign: 'center'



                      }}



                    />



                  </div>



                  



                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 10, color: '#667' }}>



                    <span>0 - Insuffisant</span>



                    <span>50 - Moyen</span>



                    <span>100 - Excellent</span>



                  </div>



                </div>







                {/* Score Respect des r�gles */}



                <div style={{ marginBottom: 24 }}>



                  <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#42a5f5', marginBottom: 8 }}>



                    ?? Respect des r�gles



                  </label>



                  <div style={{ fontSize: 11, color: '#778', marginBottom: 12, lineHeight: 1.5 }}>



                    �valuez la ponctualit�, l'hygi�ne, le respect des proc�dures et le professionnalisme



                  </div>



                  



                  <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}>



                    <input



                      type="range"



                      min="0"



                      max="100"



                      step="5"



                      value={form.score_respect_regles || 0}



                      onChange={(e) => setForm(prev => ({ ...prev, score_respect_regles: parseInt(e.target.value) }))}



                      style={{ 



                        flex: 1, 



                        height: 8, 



                        borderRadius: 4,



                        background: `linear-gradient(to right, #42a5f5 0%, #42a5f5 ${form.score_respect_regles || 0}%, #1a2332 ${form.score_respect_regles || 0}%, #1a2332 100%)`,



                        outline: 'none',



                        cursor: 'pointer'



                      }}



                    />



                    <input



                      type="number"



                      min="0"



                      max="100"



                      value={form.score_respect_regles || 0}



                      onChange={(e) => setForm(prev => ({ ...prev, score_respect_regles: Math.min(100, Math.max(0, parseInt(e.target.value) || 0)) }))}



                      style={{



                        width: 70,



                        padding: '8px 12px',



                        background: '#0d1b2a',



                        border: '1px solid rgba(255,255,255,.15)',



                        borderRadius: 8,



                        color: '#42a5f5',



                        fontSize: 14,



                        fontWeight: 700,



                        textAlign: 'center'



                      }}



                    />



                  </div>



                  



                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 10, color: '#667' }}>



                    <span>0 - Insuffisant</span>



                    <span>50 - Moyen</span>



                    <span>100 - Excellent</span>



                  </div>



                </div>







                {/* Info box */}



                <div style={{ 



                  padding: 12, 



                  background: 'rgba(102,187,106,.08)', 



                  border: '1px solid rgba(102,187,106,.25)', 



                  borderRadius: 8,



                  fontSize: 11,



                  color: '#889',



                  lineHeight: 1.6



                }}>



                  <strong style={{ color: '#66bb6a' }}>?? Impact sur le score global :</strong><br />



                  Travail en �quipe : {((form.score_travail_equipe || 0) * 0.10).toFixed(1)} pts (10%)<br />



                  Respect des r�gles : {((form.score_respect_regles || 0) * 0.05).toFixed(1)} pts (5%)<br />



                  <strong>Contribution totale : {((form.score_travail_equipe || 0) * 0.10 + (form.score_respect_regles || 0) * 0.05).toFixed(1)} pts</strong>



                </div>



              </div>







              <div className="modal-footer">



                <button className="btn-outline" onClick={closeModal}>Annuler</button>



                <button 



                  className="btn-gold" 



                  onClick={async () => {



                    try {



                      // 1. Sauvegarder les notes manuelles



                      await api.employeesCRUD.update(form.id, {



                        score_travail_equipe: form.score_travail_equipe || 0,



                        score_respect_regles: form.score_respect_regles || 0,



                      });



                      



                      // 2. Recalculer le score global via l'API Performance (optionnel mais recommand�)



                      try {



                        await api.performance.calculate(form.id);



                      } catch (perfError) {



                        console.warn('?? Calcul de performance non disponible:', perfError);



                      }



                      



                      // 3. Recharger les donn�es pour avoir les scores � jour



                      const res = await api.dashboard.getDG();



                      if (res?.employees?.length) {



                        const employeesWithTasks = res.employees.map(e => {



                          const mapped = mapEmployee(e);



                          const empTasks = (tasks || []).filter(t => t.employee_id === mapped.user_id);



                          return {



                            ...mapped,



                            assignedTasks: empTasks,



                            taches: empTasks.length,



                            done: empTasks.filter(t => t.done).length,



                          };



                        });



                        setPersonnel(employeesWithTasks);



                        setEmployes(employeesWithTasks);



                      }



                      



                      alert('? Notation enregistr�e et score global recalcul� !');



                      closeModal();



                    } catch (error) {



                      console.error('Erreur lors de la sauvegarde:', error);



                      alert('? Erreur lors de la sauvegarde de la notation');



                    }



                  }}



                >



                  ?? Enregistrer la notation



                </button>



              </div>



            </div>



          </div>



        )}







        <FormModal



          title={form.id ? 'Modifier le d�partement' : 'Nouveau d�partement'}



          isOpen={modal === 'dept'}



          onClose={closeModal}



          onSave={saveDept}



          initialData={form}



          onFieldChange={(name, value) => {



            if (name === 'filiale_id') {



              setForm(prev => ({ ...prev, filiale_id: value }));



            }



          }}



          fields={[



            { label: 'Nom', name: 'nom', required: true },



            {



              label: 'Filiale',



              name: 'filiale_id',



              type: 'select',



              opts: filiales.map(f => ({ value: f.id, label: f.nom }))



            },



            {



              label: 'Chef de d�partement',



              name: 'chef_id',



              type: 'select',



              opts: personnel.map(p => ({ value: String(p.id), label: `${p.prenom} ${p.nom_raw || ''} � ${p.poste}` }))



            },



          ]}



        />











        <FormModal



          title={form._isEdit ? 'Modifier la ligne finance' : 'Nouvelle entr�e finance'}



          isOpen={modal === 'finance'}



          onClose={closeModal}



          onSave={saveFinance}



          initialData={form}



          fields={[



            { label: 'Filiale', name: 'f', opts: ['FHC Conseil', 'FHC Technologie', 'FHC Formation', 'EMPLOI+', 'FHC Location', 'FHC Entrepreneuriat'] },



            { label: 'CA r�alis� (ex: 1 200 000 FCFA)', name: 'ca' },



            { label: 'Part du total (ex: 18%)', name: 'pct' },



            { label: 'Tendance', name: 't', opts: ['green', 'orange', 'red', 'blue'] },



            { label: 'Texte tendance (ex: +8%)', name: 'tb' },



          ]}



        />







                {/* --- MODAL PROJET --- */}



        <FormModal



          title={form._isEdit ? 'Modifier le projet' : 'Nouveau projet'}



          isOpen={modal === 'projet'}



          onClose={() => { closeModal(); setProjetFilialeId(null); }}



          onSave={saveProjet}



          initialData={form}



          onFieldChange={(name, value) => {



            if (name === 'filiale_id') {



              setProjetFilialeId(value ? Number(value) : null);



              // ?? IMPORTANT : Mettre � jour le state form du parent



              // MAIS FormModal ne r�initialisera plus gr�ce au useEffect corrig�



              setForm(prev => ({ 



                ...prev, 



                filiale_id: value,



                departement_id: '', 



                resp_id: '', 



                equipe: [] 



              }));



            }



            if (name === 'departement_id') {



              setForm(prev => ({ 



                ...prev, 



                departement_id: value,



                equipe: [] 



              }));



            }



          }}



          fields={[



            {



              label: 'Nom du projet',



              name: 'nom',



              required: true



            },



            {



              label: 'Filiale',



              name: 'filiale_id',



              type: 'select',



              required: true,



              opts: filiales.map(f => ({



                value: String(f.id),



                label: `${f.icon || '??'} ${f.nom}`



              }))



            },



            {



              label: 'D�partement',



              name: 'departement_id',



              type: 'select',



              disabled: !projetFilialeId,



              placeholder: projetFilialeId ? 'Choisir un d�partement' : 'S�lectionnez d\'abord une filiale',



              opts: projetFilialeId



                ? depts



                  .filter(d => d.filiale_id === projetFilialeId)



                  .map(d => ({ value: String(d.id), label: d.nom }))



                : []



            },



            {



              label: 'Chef de projet',



              name: 'resp_id',



              type: 'select',



              opts: personnel



                .filter(p => {



                  const deptId = form.departement_id ? Number(form.departement_id) : null;



                  if (deptId) return p.departement_id === deptId;



                  if (projetFilialeId) return p.filiale_id === projetFilialeId;



                  return true;



                })



                .map(p => ({



                  value: String(p.id),



                  label: `${p.av} ${p.nom} � ${p.poste}`



                }))



            },



            {



              label: '�quipe du projet',



              name: 'equipe',



              type: 'multiselect',



              emptyMessage: form.departement_id 



                ? 'Aucun employ� dans ce d�partement' 



                : (projetFilialeId ? 'S�lectionnez d\'abord un d�partement' : 'S�lectionnez d\'abord une filiale'),



              opts: personnel



                .filter(p => {



                  const deptId = form.departement_id ? Number(form.departement_id) : null;



                  if (deptId) return p.departement_id === deptId;



                  if (projetFilialeId) return p.filiale_id === projetFilialeId;



                  return true;



                })



                .map(p => ({



                  value: String(p.id),



                  label: `${p.av} ${p.nom} � ${p.poste}`



                }))



            },



            {



              label: 'Deadline',



              name: 'deadline',



              type: 'date',



              min: new Date().toISOString().slice(0, 10)



            },



            {



              label: 'Statut',



              name: 'statut',



              type: 'select',



              opts: [



                { value: 'planification', label: '?? Planification' },



                { value: 'en_cours', label: '?? En cours' },



                { value: 'negociation', label: '?? N�gociation' },



                { value: 'production', label: '⚙? Production' },



                { value: 'termine', label: '? Termin�' },



                { value: 'annule', label: '? Annul�' },



              ]



            },



            {



              label: 'Avancement (%)',



              name: 'av',



              type: 'number',



              min: 0,



              max: 100



            },



            {



              label: 'Budget (FCFA)',



              name: 'budget',



              type: 'number'



            },



            {



              label: 'Description',



              name: 'description',



              type: 'textarea'



            },



          ]}



        />



        <FormModal



          title={form._isEdit ? 'Modifier la d�cision' : 'Nouvelle d�cision'}



          isOpen={modal === 'decision'}



          onClose={closeModal}



          onSave={saveDecision}



          initialData={form}



          fields={[



            { label: 'D�cision', name: 'text', required: true },



            { label: 'Priorit�', name: 'prio', opts: ['URGENT', 'HAUTE', 'NORMALE'] },



            { label: 'Statut', name: 'statut', opts: ['attente', 'en_cours', 'planifie', 'termine'] },



          ]}



        />

        {/* MODAL OBJECTIF */}
        <FormModal
          title={objectifForm.id ? 'Modifier l\'objectif' : 'Nouvel objectif'}
          isOpen={modal === 'objectif'}
          onClose={() => { setModal(null); setObjectifForm({}); }}
          onSave={saveObjectif}
          initialData={objectifForm}
          fields={[
            {
              label: 'Employ�',
              name: 'employee_id',
              type: 'select',
              opts: personnel.map(p => ({ value: p.id, label: p.nom })),
              required: true
            },
            { label: 'Titre', name: 'titre', required: true },
            { label: 'Description', name: 'description', type: 'textarea' },
            {
              label: 'Type de p�riode',
              name: 'type_periode',
              type: 'select',
              opts: [
                { value: 'quotidien', label: 'Quotidien' },
                { value: 'hebdomadaire', label: 'Hebdomadaire' },
                { value: 'mensuel', label: 'Mensuel' },
                { value: 'annuel', label: 'Annuel' }
              ],
              required: true
            },
            { label: 'Date limite', name: 'deadline', type: 'date' },
          ]}
        />















        {/* MODAL DETAIL FILIALE */}



        {selectedFiliale && (



          <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.75)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => setSelectedFiliale(null)}>



            <div style={{ background: '#162535', border: '1px solid rgba(255,255,255,.12)', borderRadius: 14, padding: 28, width: '90%', maxWidth: 620, maxHeight: '85vh', overflowY: 'auto' }} onClick={e => e.stopPropagation()}>



              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>



                <div>



                  <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>



                    <div style={{ width: 12, height: 12, borderRadius: '50%', background: selectedFiliale.color }} />



                    <span style={{ fontSize: 17, fontWeight: 700, color: '#fff' }}>{selectedFiliale.nom}</span>



                    <Badge statut={selectedFiliale.statut} />



                  </div>



                  <div style={{ fontSize: 11, color: '#667', marginTop: 4 }}>{selectedFiliale.desc}</div>



                </div>



                <button onClick={() => setSelectedFiliale(null)} style={{ background: 'none', border: 'none', color: '#889', fontSize: 22, cursor: 'pointer' }}>�</button>



              </div>



              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 10, marginBottom: 20 }}>



                {[{ l: 'CA r�alis�', v: selectedFiliale.ca + ' FCFA', c: selectedFiliale.color }, { l: 'Objectif', v: selectedFiliale.obj + ' FCFA', c: '#aaa' }, { l: 'Progression', v: selectedFiliale.pct + '%', c: selectedFiliale.pct >= 70 ? '#4caf50' : '#ff9800' }].map(x => (



                  <div key={x.l} style={{ background: 'rgba(255,255,255,.04)', borderRadius: 8, padding: '10px 12px' }}>



                    <div style={{ fontSize: 10, color: '#556', marginBottom: 3 }}>{x.l}</div>



                    <div style={{ fontSize: 13, fontWeight: 700, color: x.c }}>{x.v}</div>



                  </div>



                ))}



              </div>



              <div style={{ fontSize: 11, color: '#C9A84C', fontWeight: 600, letterSpacing: 1, textTransform: 'uppercase', marginBottom: 10 }}>D�partements</div>



              {(() => {



                const filDepts = depts.filter(d => d.filiale === selectedFiliale.nom || selectedFiliale.nom.includes(d.filiale) || d.filiale.includes(selectedFiliale.nom.split(' ').slice(-1)[0]));



                return filDepts.length === 0



                  ? <div style={{ fontSize: 12, color: '#556', fontStyle: 'italic', marginBottom: 16 }}>Aucun d�partement rattach�.</div>



                  : <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 16 }}>



                    {filDepts.map(d => (



                      <div key={d.id} style={{ display: 'flex', alignItems: 'center', gap: 10, background: 'rgba(255,255,255,.03)', borderRadius: 8, padding: '8px 12px', cursor: 'pointer', border: '1px solid rgba(255,255,255,.06)' }}



                        onClick={() => { setSelectedFiliale(null); setSelectedDept(d); }}>



                        <div style={{ fontSize: 13 }}>???</div>



                        <div style={{ flex: 1 }}>



                          <div style={{ fontSize: 12, fontWeight: 600, color: '#fff' }}>{d.nom}</div>



                          <div style={{ fontSize: 10, color: '#667' }}>Chef : {d.chef} � Effectif : {d.effectif} � Budget : {d.budget}</div>



                        </div>



                        <span style={{ fontSize: 10, color: '#C9A84C' }}>Voir ?</span>



                      </div>



                    ))}



                  </div>;



              })()}



              <div style={{ fontSize: 11, color: '#C9A84C', fontWeight: 600, letterSpacing: 1, textTransform: 'uppercase', marginBottom: 10 }}>Personnel</div>



              {(() => {



                const membres = personnel.filter(p => p.filiale === selectedFiliale.nom || selectedFiliale.nom.includes(p.filiale) || p.filiale.includes(selectedFiliale.nom.split(' ').slice(-1)[0]));



                return membres.length === 0



                  ? <div style={{ fontSize: 12, color: '#556', fontStyle: 'italic' }}>Aucun collaborateur enregistr�.</div>



                  : membres.map(p => (



                    <div key={p.nom} className="pers-item">



                      <div className="pers-av" style={{ background: p.color + '22', color: p.color }}>{p.av}</div>



                      <div><div className="pers-name">{p.nom}</div><div className="pers-role">{p.poste} {p.departement ? '� ' + p.departement : ''}</div></div>



                      <div className="pers-status">



                        {p.present ? <span style={{ fontSize: 10, color: '#66bb6a' }}>? Pr�sent</span> : <span style={{ fontSize: 10, color: '#ef5350' }}>? Absent</span>}



                        <span style={{ fontSize: 10, color: '#556' }}>{p.arr}</span>



                      </div>



                    </div>



                  ));



              })()}



              <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 20 }}>



                <button className="btn-outline" onClick={() => setSelectedFiliale(null)}>Fermer</button>



              </div>



            </div>



          </div>



        )}







        {/* MODAL DETAIL D�PARTEMENT */}



        {selectedDept && (



          <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.75)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => setSelectedDept(null)}>



            <div style={{ background: '#162535', border: '1px solid rgba(255,255,255,.12)', borderRadius: 14, padding: 28, width: '90%', maxWidth: 560, maxHeight: '85vh', overflowY: 'auto' }} onClick={e => e.stopPropagation()}>



              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>



                <div>



                  <div style={{ fontSize: 17, fontWeight: 700, color: '#fff', marginBottom: 4 }}>{selectedDept.nom}</div>



                  <div style={{ fontSize: 11, color: '#667' }}>Filiale : {selectedDept.filiale}</div>



                </div>



                <button onClick={() => setSelectedDept(null)} style={{ background: 'none', border: 'none', color: '#889', fontSize: 22, cursor: 'pointer' }}>�</button>



              </div>



              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 10, marginBottom: 20 }}>



                {[{ l: 'Chef', v: selectedDept.chef, c: '#C9A84C' }, { l: 'Effectif', v: selectedDept.effectif + ' personnes', c: '#42a5f5' }, { l: 'Budget', v: selectedDept.budget, c: '#66bb6a' }].map(x => (



                  <div key={x.l} style={{ background: 'rgba(255,255,255,.04)', borderRadius: 8, padding: '10px 12px' }}>



                    <div style={{ fontSize: 10, color: '#556', marginBottom: 3 }}>{x.l}</div>



                    <div style={{ fontSize: 13, fontWeight: 700, color: x.c }}>{x.v}</div>



                  </div>



                ))}



              </div>



              {(() => {



                const chef = personnel.find(p => p.nom.toLowerCase().includes(selectedDept.chef?.split(' ')[0]?.toLowerCase() || ''));



                return chef ? (



                  <div style={{ background: 'rgba(201,168,76,.08)', border: '1px solid rgba(201,168,76,.2)', borderRadius: 10, padding: '12px 14px', marginBottom: 16 }}>



                    <div style={{ fontSize: 10, color: '#C9A84C', fontWeight: 600, letterSpacing: 1, textTransform: 'uppercase', marginBottom: 8 }}>Chef de d�partement</div>



                    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>



                      <div style={{ width: 36, height: 36, borderRadius: '50%', background: chef.color + '22', color: chef.color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 700 }}>{chef.av}</div>



                      <div>



                        <div style={{ fontSize: 13, fontWeight: 600, color: '#fff' }}>{chef.nom}</div>



                        <div style={{ fontSize: 11, color: '#667' }}>{chef.poste}</div>



                      </div>



                      <div style={{ marginLeft: 'auto' }}>



                        {chef.present ? <span style={{ fontSize: 11, color: '#66bb6a' }}>? Pr�sent</span> : <span style={{ fontSize: 11, color: '#ef5350' }}>? Absent</span>}



                      </div>



                    </div>



                  </div>



                ) : null;



              })()}



              <div style={{ fontSize: 11, color: '#C9A84C', fontWeight: 600, letterSpacing: 1, textTransform: 'uppercase', marginBottom: 10 }}>Employ�s du d�partement</div>



              {(() => {



                const membres = personnel.filter(p => p.departement === selectedDept.nom);



                return membres.length === 0



                  ? <div style={{ fontSize: 12, color: '#556', fontStyle: 'italic' }}>Aucun employ� assign� � ce d�partement.</div>



                  : membres.map(p => (



                    <div key={p.nom} className="pers-item">



                      <div className="pers-av" style={{ background: p.color + '22', color: p.color }}>{p.av}</div>



                      <div><div className="pers-name">{p.nom}</div><div className="pers-role">{p.poste}</div></div>



                      <div className="pers-status">



                        {p.present ? <span style={{ fontSize: 10, color: '#66bb6a' }}>? Pr�sent</span> : <span style={{ fontSize: 10, color: '#ef5350' }}>? Absent</span>}



                        <span style={{ fontSize: 10, color: '#556' }}>{p.arr}</span>



                      </div>



                    </div>



                  ));



              })()}



              <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 20 }}>



                <button className="btn-outline" onClick={() => setSelectedDept(null)}>Fermer</button>



              </div>



            </div>



          </div>



        )}







        {/* MODAL DETAIL PROJET */}



        {selectedProjet && (



          <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.75)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => setSelectedProjet(null)}>



            <div style={{ background: '#162535', border: '1px solid rgba(255,255,255,.12)', borderRadius: 14, padding: 28, width: '90%', maxWidth: 560 }} onClick={e => e.stopPropagation()}>



              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20 }}>



                <div>



                  <div style={{ fontSize: 16, fontWeight: 700, color: '#fff', marginBottom: 6 }}>{selectedProjet.nom}</div>



                  <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>



                    <Badge statut={selectedProjet.statut} />



                    <span style={{ fontSize: 11, color: '#667' }}>{selectedProjet.filiale}</span>



                  </div>



                </div>



                <button onClick={() => setSelectedProjet(null)} style={{ background: 'none', border: 'none', color: '#889', fontSize: 22, cursor: 'pointer' }}>�</button>



              </div>



              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 20 }}>



                {[{ l: 'Deadline', v: selectedProjet.deadline }, { l: 'Avancement', v: selectedProjet.av + '%' }, { l: 'Budget', v: fmt(selectedProjet.budget) + ' FCFA' }, { l: 'D�penses', v: fmt(selectedProjet.dep) + ' FCFA' }].map(x => (



                  <div key={x.l} style={{ background: 'rgba(255,255,255,.04)', borderRadius: 8, padding: '12px 14px' }}>



                    <div style={{ fontSize: 10, color: '#556', marginBottom: 4 }}>{x.l}</div>



                    <div style={{ fontSize: 14, fontWeight: 700, color: '#fff' }}>{x.v}</div>



                  </div>



                ))}



              </div>



              <div style={{ marginBottom: 16 }}>



                <div style={{ fontSize: 10, color: '#556', marginBottom: 6 }}>AVANCEMENT</div>



                <Pbar pct={selectedProjet.av} />



              </div>



              <div style={{ background: 'rgba(201,168,76,.08)', border: '1px solid rgba(201,168,76,.2)', borderRadius: 10, padding: '14px 16px', marginBottom: 16 }}>



                <div style={{ fontSize: 10, color: '#C9A84C', fontWeight: 600, letterSpacing: 1, textTransform: 'uppercase', marginBottom: 10 }}>Chef de projet</div>



                {(() => {



                  const chef = personnel.find(p => p.nom.toLowerCase().includes(selectedProjet.resp?.toLowerCase()) || selectedProjet.resp?.toLowerCase().includes(p.nom.split('.')[0].toLowerCase()));



                  return chef ? (



                    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>



                      <div style={{ width: 38, height: 38, borderRadius: '50%', background: chef.color + '22', color: chef.color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, fontWeight: 700 }}>{chef.av}</div>



                      <div>



                        <div style={{ fontSize: 13, fontWeight: 600, color: '#fff' }}>{chef.nom}</div>



                        <div style={{ fontSize: 11, color: '#667' }}>{chef.poste} � {chef.filiale}</div>



                      </div>



                      <div style={{ marginLeft: 'auto' }}>



                        {chef.present ? <span style={{ fontSize: 11, color: '#66bb6a' }}>? Pr�sent</span> : <span style={{ fontSize: 11, color: '#ef5350' }}>? Absent</span>}



                      </div>



                    </div>



                  ) : (



                    <div style={{ fontSize: 12, color: '#aaa' }}>{selectedProjet.resp}</div>



                  );



                })()}



              </div>



              <div>



                <div style={{ fontSize: 10, color: '#556', marginBottom: 8 }}>MEMBRES DE L'�QUIPE</div>



                {(() => {



                  const membres = personnel.filter(p => (selectedProjet.equipe || []).map(Number).includes(Number(p.id)));



                  return membres.length === 0



                    ? <div style={{ fontSize: 12, color: '#556', fontStyle: 'italic' }}>Aucun membre assign�.</div>



                    : <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>



                        {membres.map(p => (



                          <div key={p.id} style={{ display: 'flex', alignItems: 'center', gap: 10, background: 'rgba(255,255,255,.03)', borderRadius: 8, padding: '8px 12px', border: '1px solid rgba(255,255,255,.06)' }}>



                            <div style={{ width: 32, height: 32, borderRadius: '50%', background: p.color + '22', color: p.color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 700, flexShrink: 0 }}>{p.av}</div>



                            <div style={{ flex: 1 }}>



                              <div style={{ fontSize: 12, fontWeight: 600, color: '#fff' }}>{p.nom}</div>



                              <div style={{ fontSize: 10, color: '#667' }}>{p.poste}{p.departement ? ' � ' + p.departement : ''}</div>



                            </div>



                            <div>{p.present ? <span style={{ fontSize: 10, color: '#66bb6a' }}>? Pr�sent</span> : <span style={{ fontSize: 10, color: '#ef5350' }}>? Absent</span>}</div>



                          </div>



                        ))}



                      </div>;



                })()}



              </div>



              <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 20 }}>



                <button className="btn-outline" onClick={() => setSelectedProjet(null)}>Fermer</button>



              </div>



            </div>



          </div>



        )}







      </div>



{/* Modal Approbation/Refus */}
{modalDemande && actionType !== 'details' && (
  <div className="modal-overlay" onClick={() => setModalDemande(null)}>
    <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 600 }}>
      <div className="modal-header">
        <div>
          <div className="modal-title">
            {actionType === 'approuver' ? '? Approuver la demande' : '? Refuser la demande'}
          </div>
          <div style={{ fontSize: 12, color: '#778', marginTop: 4 }}>
            {modalDemande.employee?.user?.prenom} {modalDemande.employee?.user?.nom || modalDemande.user?.nom}
          </div>
        </div>
        <button className="modal-close" onClick={() => setModalDemande(null)}>?</button>
      </div>

      <div className="modal-body" style={{ padding: 24 }}>
        {/* R�sum� de la demande */}
        <div style={{
          padding: 16,
          background: 'rgba(201,168,76,.08)',
          border: '1px solid rgba(201,168,76,.25)',
          borderRadius: 8,
          marginBottom: 20
        }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, fontSize: 13 }}>
            <div>
              <div style={{ color: '#889', fontSize: 11, marginBottom: 4 }}>Type</div>
              <div style={{ fontWeight: 600 }}>{modalDemande.type_label}</div>
            </div>
            <div>
              <div style={{ color: '#889', fontSize: 11, marginBottom: 4 }}>Dur�e</div>
              <div style={{ fontWeight: 600 }}>{modalDemande.nombre_jours} jour{modalDemande.nombre_jours > 1 ? 's' : ''}</div>
            </div>
            <div>
              <div style={{ color: '#889', fontSize: 11, marginBottom: 4 }}>Du</div>
              <div style={{ fontWeight: 600 }}>{new Date(modalDemande.date_debut).toLocaleDateString('fr-FR')}</div>
            </div>
            <div>
              <div style={{ color: '#889', fontSize: 11, marginBottom: 4 }}>Au</div>
              <div style={{ fontWeight: 600 }}>{new Date(modalDemande.date_fin).toLocaleDateString('fr-FR')}</div>
            </div>
          </div>
          <div style={{ marginTop: 12, paddingTop: 12, borderTop: '1px solid rgba(255,255,255,.1)' }}>
            <div style={{ color: '#889', fontSize: 11, marginBottom: 4 }}>Raison</div>
            <div style={{ fontSize: 13, lineHeight: 1.6 }}>{modalDemande.raison}</div>
          </div>
        </div>

        {/* Commentaire */}
        <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 8, color: '#ccc' }}>
            Commentaire {actionType === 'refuser' && <span style={{ color: '#ef5350' }}>*</span>}
          </label>
          <textarea
            value={commentaireDG}
            onChange={(e) => setCommentaireDG(e.target.value)}
            placeholder={
              actionType === 'approuver'
                ? 'Commentaire optionnel...'
                : 'Expliquez la raison du refus (obligatoire)...'
            }
            style={{
              width: '100%',
              padding: 12,
              background: 'rgba(255,255,255,.05)',
              border: '1px solid rgba(255,255,255,.15)',
              borderRadius: 8,
              color: '#fff',
              fontSize: 14,
              fontFamily: 'inherit',
              resize: 'vertical',
              minHeight: 80
            }}
          />
          {actionType === 'refuser' && commentaireDG.length < 10 && (
            <div style={{ fontSize: 11, color: '#ef5350', marginTop: 4 }}>
              Le commentaire doit contenir au moins 10 caract�res
            </div>
          )}
        </div>

        {/* Alerte pour refus */}
        {actionType === 'refuser' && (
          <div style={{
            padding: 12,
            background: 'rgba(239,83,80,.08)',
            border: '1px solid rgba(239,83,80,.25)',
            borderRadius: 8,
            fontSize: 12,
            color: '#ef8080'
          }}>
            ?? L'employ� sera notifi� du refus avec votre commentaire
          </div>
        )}
      </div>

      <div className="modal-footer">
        <button className="btn-outline" onClick={() => setModalDemande(null)}>
          Annuler
        </button>
        <button
          className={actionType === 'approuver' ? 'btn-gold' : 'btn-outline'}
          style={actionType === 'refuser' ? { 
            background: 'rgba(239,83,80,.15)',
            borderColor: '#ef5350',
            color: '#ef5350'
          } : {}}
          onClick={async () => {
            if (actionType === 'refuser' && commentaireDG.length < 10) {
              alert('Le commentaire doit contenir au moins 10 caract�res');
              return;
            }

            try {
              if (actionType === 'approuver') {
                await api.demandesPermission.approuver(modalDemande.id, commentaireDG);
                alert('? Demande approuv�e !');
              } else {
                await api.demandesPermission.refuser(modalDemande.id, commentaireDG);
                alert('? Demande refus�e');
              }
              setModalDemande(null);
              setCommentaireDG('');
              loadDemandesPermission();
            } catch (error) {
              console.error('Erreur:', error);
              alert('? ' + (error.message || 'Erreur lors du traitement'));
            }
          }}
        >
          {actionType === 'approuver' ? '? Approuver' : '? Refuser d�finitivement'}
        </button>
      </div>
    </div>
  </div>
)}

{/* Modal D�tails */}
{modalDemande && actionType === 'details' && (
  <div className="modal-overlay" onClick={() => setModalDemande(null)}>
    <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 600 }}>
      <div className="modal-header">
        <div className="modal-title">??? D�tails de la demande</div>
        <button className="modal-close" onClick={() => setModalDemande(null)}>?</button>
      </div>

      <div className="modal-body" style={{ padding: 24 }}>
        <div style={{
          padding: 16,
          background: 'rgba(201,168,76,.08)',
          border: '1px solid rgba(201,168,76,.25)',
          borderRadius: 8,
          marginBottom: 16
        }}>
          <h4 style={{ margin: '0 0 12px 0', fontSize: 14, color: '#C9A84C' }}>Informations</h4>
          <div style={{ display: 'grid', gap: 8, fontSize: 13 }}>
            <div><strong>Employ�:</strong> {modalDemande.employee?.user?.prenom} {modalDemande.employee?.user?.nom || modalDemande.user?.nom}</div>
            <div><strong>Type:</strong> {modalDemande.type_label}</div>
            <div><strong>P�riode:</strong> Du {new Date(modalDemande.date_debut).toLocaleDateString('fr-FR')} au {new Date(modalDemande.date_fin).toLocaleDateString('fr-FR')}</div>
            <div><strong>Dur�e:</strong> {modalDemande.nombre_jours} jour{modalDemande.nombre_jours > 1 ? 's' : ''}</div>
            <div><strong>Date demande:</strong> {new Date(modalDemande.created_at).toLocaleDateString('fr-FR')}</div>
            {modalDemande.date_decision && (
              <div><strong>Date d�cision:</strong> {new Date(modalDemande.date_decision).toLocaleDateString('fr-FR')}</div>
            )}
            {modalDemande.traite_par && (
              <div><strong>Trait� par:</strong> {modalDemande.traite_par_user?.nom || 'DG'}</div>
            )}
          </div>
        </div>

        <div style={{ marginBottom: 16 }}>
          <h4 style={{ margin: '0 0 8px 0', fontSize: 14 }}>Raison</h4>
          <div style={{
            padding: 12,
            background: 'rgba(255,255,255,.05)',
            borderRadius: 8,
            fontSize: 13,
            lineHeight: 1.6
          }}>
            {modalDemande.raison}
          </div>
        </div>

        {modalDemande.commentaire_dg && (
          <div>
            <h4 style={{ margin: '0 0 8px 0', fontSize: 14 }}>Commentaire DG</h4>
            <div style={{
              padding: 12,
              background: 'rgba(66,165,245,.08)',
              border: '1px solid rgba(66,165,245,.25)',
              borderRadius: 8,
              fontSize: 13,
              lineHeight: 1.6,
              color: '#89b4d8'
            }}>
              {modalDemande.commentaire_dg}
            </div>
          </div>
        )}
      </div>

      <div className="modal-footer">
        <button className="btn-outline" onClick={() => setModalDemande(null)}>
          Fermer
        </button>
      </div>
    </div>
  </div>
)}



    </MainLayout>



  );



}







// -- Donut SVG -----------------------------------------------------------------



function DonutChart({ items }) {



  const r = 35, cx = 50, cy = 50, circ = 2 * Math.PI * r;



  let offset = 0;



  return (



    <svg className="donut-svg" width="100" height="100" viewBox="0 0 100 100">



      <circle cx={cx} cy={cy} r={r} fill="none" stroke="rgba(255,255,255,.05)" strokeWidth="14" />



      {items.map(it => {



        const dash = (it.val / 100) * circ;



        const el = (



          <circle key={it.label} cx={cx} cy={cy} r={r} fill="none" stroke={it.color} strokeWidth="14"



            strokeDasharray={`${dash} ${circ - dash}`}



            strokeDashoffset={-offset}



            transform={`rotate(-90 ${cx} ${cy})`} />



        );



        offset += dash;



        return el;



      })}



    </svg>



  );



}







// -- Graphique barres CA --------------------------------------------------------



function CAChart({ rows = [] }) {



  if (!rows.length) return <div style={{ padding: 20, textAlign: 'center', color: '#445', fontSize: 12 }}>Aucune donn�e financi�re disponible.</div>;



  const vals = rows.map(r => parseFloat(String(r.ca).replace(/[^\d.]/g, '')) || 0);



  const max = Math.max(...vals, 1);



  return (



    <div style={{ padding: '10px 0' }}>



      <div style={{ display: 'flex', alignItems: 'flex-end', gap: 8, height: 120, paddingBottom: 24, position: 'relative' }}>



        {rows.map((r, i) => (



          <div key={i} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4, height: '100%', justifyContent: 'flex-end' }}>



            <div style={{ fontSize: 9, color: '#667' }}>{fmt(vals[i])}</div>



            <div style={{ width: '100%', background: i === rows.length - 1 ? '#C9A84C' : 'rgba(201,168,76,.35)', borderRadius: '4px 4px 0 0', height: Math.round(vals[i] / max * 80), transition: 'height .5s' }} />



            <div style={{ fontSize: 9, color: '#556', position: 'absolute', bottom: 0 }}>{(r.f || '').split(' ').pop()}</div>



          </div>



        ))}



      </div>



      <div style={{ fontSize: 10, color: '#445', textAlign: 'right', marginTop: 4 }}>CA par filiale</div>



    </div>



  );



}







export default DashboardDGPage;







